var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 963.712,
    height: 652.292,
    viewBox: "0 0 963.712 652.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_404_Error_Page_not_Found_with_people_connecting_a_plug-pana",
    "data-name": "404 Error Page not Found with people connecting a plug-pana",
    transform: "translate(-47.482 -28.63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-65",
    transform: "translate(97.242 67.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5421",
    "data-name": "Path 5421",
    d: "M681.239,127.673a16.84,16.84,0,0,0-19.88-3.563h.073a17.277,17.277,0,0,0-4.363,32.866,20.243,20.243,0,0,0,13.7.669,21.218,21.218,0,0,0,11.125-7.5,18.353,18.353,0,0,0-.655-22.468Z",
    transform: "translate(175 -24.569)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5422",
    "data-name": "Path 5422",
    d: "M355.5,451.821a14.877,14.877,0,0,0-19.589-4.188h.073c-7.271,1.309-13.321,8.638-14.281,17.146s3.3,17.451,9.976,20.941a17.131,17.131,0,0,0,13.51.785,21.13,21.13,0,0,0,10.965-8.725C360.923,470.3,360.792,458.845,355.5,451.821Z",
    transform: "translate(27.263 122.288)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5423",
    "data-name": "Path 5423",
    d: "M286.377,59.011a9.394,9.394,0,0,0-12.4-2.6h0c-4.566.829-8.435,5.483-9.045,10.863s2.094,11.052,6.311,13.263a10.936,10.936,0,0,0,8.551.494,13.423,13.423,0,0,0,6.951-5.512,15.4,15.4,0,0,0-.364-16.506Z",
    transform: "translate(1.495 -55.101)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5424",
    "data-name": "Path 5424",
    d: "M656.986,114.988c-6.631-19.894-29.332-34.9-49.954-38.654-16.855-2.589-35.833-.829-51.626,7.606s-29.391,21.988-35.12,38.945-2.545,37.331,10.18,49.954,35.047,15.182,48.848,3.752c8.536-7.068,13.525-18.5,23.646-23.021,14.4-6.413,32.983,3.985,46.289-4.465C659.851,142.372,660.971,126.927,656.986,114.988Z",
    transform: "translate(116.287 -45.957)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5425",
    "data-name": "Path 5425",
    d: "M498.73,443.216c3.985-16.986-5.541-37.52-18.513-49.2-10.805-9.205-25.013-16.244-39.89-17.175s-30.423,2.749-41.9,12.274-18.12,25.333-14.63,39.832,18.207,26.06,32.968,24c9.133-1.28,17.655-7.271,26.816-5.992,12.987,1.745,21.625,17.233,34.728,17.058C488.8,463.881,496.345,453.425,498.73,443.216Z",
    transform: "translate(55.11 90.988)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5426",
    "data-name": "Path 5426",
    d: "M147.578,141.217c10.049-4.814,19.632-11.3,26.089-21.465a37.345,37.345,0,0,0,0-39.861c-.611-.96-1.265-1.891-1.978-2.807-4.988-6.326-13.088-10.791-21-9.394-9.089,1.585-15.444,10.02-24.082,13.277-9.744,3.679-21.159.349-30.743,4.363s-15.11,15.5-14.034,25.929,7.78,19.734,16.3,25.8a49.968,49.968,0,0,0,49.445,4.159Z",
    transform: "translate(-81.699 -49.5)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stains--inject-65",
    transform: "translate(47.482 225.355)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5427",
    "data-name": "Path 5427",
    d: "M49.021,277.708c-6.122-35.338,6.166-74.371,34.364-96.5s72.029-23.777,99.355-.567c19.211,16.331,28.2,41.257,39.643,63.726s28.78,45.213,53.691,49.1c21.494,3.345,43.1-8.406,64.671-5.584,21.058,2.749,38.683,19.967,44.747,40.312s1.454,42.959-9.336,61.2-27.631,32.444-45.882,43.206c-58.883,34.626-137.02,33.448-194.87-2.807S42.564,323.618,48.148,255.516",
    transform: "translate(-47.482 -163.906)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10536",
    "data-name": "Group 10536",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5428",
    "data-name": "Path 5428",
    d: "M49.021,277.708c-6.122-35.338,6.166-74.371,34.364-96.5s72.029-23.777,99.355-.567c19.211,16.331,28.2,41.257,39.643,63.726s28.78,45.213,53.691,49.1c21.494,3.345,43.1-8.406,64.671-5.584,21.058,2.749,38.683,19.967,44.747,40.312s1.454,42.959-9.336,61.2-27.631,32.444-45.882,43.206c-58.883,34.626-137.02,33.448-194.87-2.807S42.564,323.618,48.148,255.516",
    transform: "translate(-47.482 -163.906)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5429",
    "data-name": "Path 5429",
    d: "M313.015,490.156c19.123-13.088,28.111-41.824,16.157-61.646h0c-12.1-18.033-30.888-32.415-52.353-35.455s-45.3,7.126-54.869,26.627c-6.035,12.274-6.05,27.107-1.047,39.832a63.3,63.3,0,0,0,26.453,30.409C267.119,501.878,293.95,503.216,313.015,490.156Z",
    transform: "translate(29.649 -60.054)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10537",
    "data-name": "Group 10537",
    transform: "translate(246.926 332.471)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5430",
    "data-name": "Path 5430",
    d: "M313.015,490.156c19.123-13.088,28.111-41.824,16.157-61.646h0c-12.1-18.033-30.888-32.415-52.353-35.455s-45.3,7.126-54.869,26.627c-6.035,12.274-6.05,27.107-1.047,39.832a63.3,63.3,0,0,0,26.453,30.409C267.119,501.878,293.95,503.216,313.015,490.156Z",
    transform: "translate(-217.277 -392.525)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5431",
    "data-name": "Path 5431",
    d: "M804.5,405.68c-1.178-30.612-16.346-60.962-41.737-78.094s-60.744-19.473-86.906-3.548c-16.3,9.918-28.125,25.711-37.971,42.057-5.4,8.958-11.023,18.833-20.723,22.745-12.608,5.1-26.467-1.847-39.8-4.508a62.62,62.62,0,0,0-72.713,44.995c-11.634,48.267,22.207,82.718,58.388,103.63,40.443,23.384,91.618,23.355,135.595,7.766,28.867-10.18,55.771-27.049,75.432-50.535S805.694,436.292,804.5,405.68Z",
    transform: "translate(159.129 -96.034)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10538",
    "data-name": "Group 10538",
    transform: "translate(661.446 217.285)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5432",
    "data-name": "Path 5432",
    d: "M804.5,405.68c-1.178-30.612-16.346-60.962-41.737-78.094s-60.744-19.473-86.906-3.548c-16.3,9.918-28.125,25.711-37.971,42.057-5.4,8.958-11.023,18.833-20.723,22.745-12.608,5.1-26.467-1.847-39.8-4.508a62.62,62.62,0,0,0-72.713,44.995c-11.634,48.267,22.207,82.718,58.388,103.63,40.443,23.384,91.618,23.355,135.595,7.766,28.867-10.18,55.771-27.049,75.432-50.535S805.694,436.292,804.5,405.68Z",
    transform: "translate(-502.316 -313.319)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5433",
    "data-name": "Path 5433",
    d: "M699.885,210.809c-3.738-24.432-27.3-46.391-51.888-44.035h0c-22.963,3.33-45.489,14.775-58.345,34.088s-14.063,46.9.291,65.122c9.031,11.474,23.268,18.353,37.811,19.414a67.594,67.594,0,0,0,41.49-11.43C689.967,260.443,703.623,235.27,699.885,210.809Z",
    transform: "translate(194.232 -162.681)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10539",
    "data-name": "Group 10539",
    transform: "translate(773.824 3.919)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5434",
    "data-name": "Path 5434",
    d: "M699.885,210.809c-3.738-24.432-27.3-46.391-51.888-44.035h0c-22.963,3.33-45.489,14.775-58.345,34.088s-14.063,46.9.291,65.122c9.031,11.474,23.268,18.353,37.811,19.414a67.594,67.594,0,0,0,41.49-11.43C689.967,260.443,703.623,235.27,699.885,210.809Z",
    transform: "translate(-579.592 -166.601)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-65",
    transform: "translate(505.721 273.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5435",
    "data-name": "Path 5435",
    d: "M466.52,202.924c3.17-.393,5.686-2.719,8.566-4.072a14.863,14.863,0,0,1,13.7.684c4.086,2.443,6.995,5.381,7.271,10.18l-5.337,5.817",
    transform: "translate(-315.37 -196.574)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5436",
    "data-name": "Path 5436",
    d: "M505.291,230.646l-8.58,51.5c-1.454,8.726-5.381,21.334-19.123,18.4h0c-11.736-3.447-12.885-15.342-11.518-23.515.654-3.883,1.193-7.111,1.222-7.519,0,0-12.9-3.418-11.634-16.549.6-6.341,2.909-19.327,5.061-31.034a24.577,24.577,0,0,1,26.657-19.88l1.265.131C502.208,204.382,507.894,217.136,505.291,230.646Z",
    transform: "translate(-320.344 -194.57)",
    fill: "#f4d3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5437",
    "data-name": "Path 5437",
    d: "M463.748,249.218a30.685,30.685,0,0,0,17.611-3.068s-5.032,9.016-17.989,6.471Z",
    transform: "translate(-316.801 -174.475)",
    fill: "#eaae94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5438",
    "data-name": "Path 5438",
    d: "M459.9,221.446c.262.233,2.036-.436,4.465-.145s4.13,1.352,4.363,1.163-.116-.48-.858-.96a8.392,8.392,0,0,0-3.5-1.192,7.5,7.5,0,0,0-3.577.378C460.059,221,459.769,221.344,459.9,221.446Z",
    transform: "translate(-318.392 -186.243)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5439",
    "data-name": "Path 5439",
    d: "M473.6,222.965c.262.233,2.036-.422,4.45-.131s4.116,1.338,4.363,1.163-.116-.48-.858-.96a8.842,8.842,0,0,0-3.49-1.178,7.853,7.853,0,0,0-3.563.364C473.745,222.529,473.469,222.864,473.6,222.965Z",
    transform: "translate(-312.168 -185.538)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5440",
    "data-name": "Path 5440",
    d: "M473.283,225.183a1.451,1.451,0,1,0,1.629-1.149A1.454,1.454,0,0,0,473.283,225.183Z",
    transform: "translate(-312.302 -184.527)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5441",
    "data-name": "Path 5441",
    d: "M460.333,223.763a1.452,1.452,0,1,0,1.629-1.149A1.454,1.454,0,0,0,460.333,223.763Z",
    transform: "translate(-318.185 -185.172)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5442",
    "data-name": "Path 5442",
    d: "M469.52,236.942a12.8,12.8,0,0,0-3.214-.931c-.509-.116-.989-.262-1.032-.625a2.575,2.575,0,0,1,.509-1.454c.611-1.193,1.251-2.443,1.934-3.752a71.5,71.5,0,0,0,4.494-9.889c-.218-.116-2.589,4.145-5.279,9.5l-1.774,3.752a2.909,2.909,0,0,0-.48,1.992,1.323,1.323,0,0,0,.771.843,3.722,3.722,0,0,0,.858.218,13.176,13.176,0,0,0,3.214.349Z",
    transform: "translate(-316.218 -186.222)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5443",
    "data-name": "Path 5443",
    d: "M475.261,216.908c.131.524,1.92.465,3.985.945s3.679,1.251,4.014.829-.1-.713-.727-1.265a6.719,6.719,0,0,0-2.909-1.454,6.457,6.457,0,0,0-3.2,0C475.639,216.312,475.217,216.661,475.261,216.908Z",
    transform: "translate(-311.401 -188.279)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5444",
    "data-name": "Path 5444",
    d: "M460.612,217.093c.16.436,1.934.305,3.985.611s3.723.873,4.014.494-.145-.582-.814-1.018a7.751,7.751,0,0,0-6.079-.844C460.946,216.57,460.554,216.89,460.612,217.093Z",
    transform: "translate(-318.057 -188.144)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5445",
    "data-name": "Path 5445",
    d: "M488.9,228.322c.233-.073,9.293-1.731,8.071,7.271s-9.947,5.817-9.933,5.6S488.9,228.322,488.9,228.322Z",
    transform: "translate(-306.049 -182.648)",
    fill: "#f4d3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5446",
    "data-name": "Path 5446",
    d: "M489.245,237.141a2.5,2.5,0,0,0,.378.291,1.585,1.585,0,0,0,1.163.189,3.9,3.9,0,0,0,2.254-3.214,5.018,5.018,0,0,0-.131-2.3,1.789,1.789,0,0,0-1-1.352.8.8,0,0,0-.974.305c-.16.233-.116.422-.174.422s-.174-.174,0-.538a1.032,1.032,0,0,1,.422-.509,1.178,1.178,0,0,1,.9-.1,2.2,2.2,0,0,1,1.454,1.6,5.38,5.38,0,0,1,.2,2.574,4.087,4.087,0,0,1-2.807,3.548,1.687,1.687,0,0,1-1.454-.436C489.231,237.373,489.2,237.141,489.245,237.141Z",
    transform: "translate(-305.055 -181.68)",
    fill: "#eaae94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5447",
    "data-name": "Path 5447",
    d: "M457.35,219.626a19.022,19.022,0,0,0,17.233-2.021c3.476-2.37,6.341-6.006,10.471-6.806a10.689,10.689,0,0,1,8.028,1.963,20.651,20.651,0,0,1,5.584,6.326c-3.228,6.4-2.312,14.019-1.309,21.116a3.563,3.563,0,0,0,.829,2.181,2.908,2.908,0,0,0,3.65-.407,11.168,11.168,0,0,0,3.054-5.6,37.126,37.126,0,0,0,1.454-14.543,25.232,25.232,0,0,0-5.57-13.394,23.879,23.879,0,0,0-16-8.057,29.3,29.3,0,0,0-17.582,4.276,17.277,17.277,0,0,0-6.166,5.817",
    transform: "translate(-319.536 -195.301)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5448",
    "data-name": "Path 5448",
    d: "M461.892,233.593c.843-3.607,1.236-8.158,2.08-11.765a21.959,21.959,0,0,0,16.2-4.028c2.385-1.847,4.45-4.363,7.344-5.177,3.737-1.076,7.606.887,10.994,2.792l-.131-.16a16.506,16.506,0,0,1,4.363,4.508,51.276,51.276,0,0,0-1.643,21.814,3.737,3.737,0,0,0,1.7,2.69c1.847,1.12,3.228-.145,4.625-1,1.018-.64,2.472-1.047,3.345-.218a50.9,50.9,0,0,0,5.9-14.543,3.665,3.665,0,0,0,6.457,3.228,7.721,7.721,0,0,1-1.774-3.665,4.741,4.741,0,0,0,6.762-.538l-2.836-2.909,4.043.218a21.6,21.6,0,0,1-7.678-6.646,33.36,33.36,0,0,0-7.14-7.271c-2.909-1.861-6.748-2.618-9.714-.9.2-4.726-3.185-9.1-7.475-11.1a30.656,30.656,0,0,0-16.259-1.614c-3.577.756-7.271,2.909-11.939,6.268a43.545,43.545,0,0,0-6.2,5.352c-2.821,2.981-8.449,7.868-13.845,6.413l.48,5.555c2.909,2.778,8.915.334,8.915.334s-3.461,3.447-6.7,3.359l.873,4.77s4.9.858,7.053-2.909Z",
    transform: "translate(-323.292 -196.863)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5449",
    "data-name": "Path 5449",
    d: "M501.309,215.916s-.422-.7-1.309-1.876a16.607,16.607,0,0,0-4.508-4.159,17.1,17.1,0,0,0-3.956-1.454,8.537,8.537,0,0,0-4.726-.116c-3.287.989-5.686,4.363-9.205,6.442A20.258,20.258,0,0,1,466.669,218a24.935,24.935,0,0,1-2.589-.116,2.37,2.37,0,0,0-1.076,0,11.209,11.209,0,0,0-1.033.509,9.858,9.858,0,0,0-2.763,3.1,7.81,7.81,0,0,1-5.381,3.185,8.945,8.945,0,0,1-1.716,0,2.065,2.065,0,0,1-.582-.1c0-.073.829,0,2.254-.218a7.722,7.722,0,0,0,5.017-3.214,9.977,9.977,0,0,1,2.909-3.316,9.762,9.762,0,0,1,1.105-.553,3.039,3.039,0,0,1,1.338-.116,23.823,23.823,0,0,0,2.516.087,20,20,0,0,0,10.572-3.2,37.677,37.677,0,0,0,4.61-3.563,13.8,13.8,0,0,1,4.785-2.909,9.132,9.132,0,0,1,5.061.16,17.45,17.45,0,0,1,4.057,1.658,15.663,15.663,0,0,1,4.479,4.45,10.386,10.386,0,0,1,.873,1.454C501.266,215.712,501.338,215.9,501.309,215.916Z",
    transform: "translate(-322.18 -192.129)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5450",
    "data-name": "Path 5450",
    d: "M499.745,221.387a1.779,1.779,0,0,1-.247.742,6.735,6.735,0,0,1-1.134,1.861,3.476,3.476,0,0,1-3.112,1.265,2.443,2.443,0,0,1-1.76-1.251,3.636,3.636,0,0,1-.393-2.254l.669.174a2.908,2.908,0,0,1-2.53,1.7,3.548,3.548,0,0,1-2.647-.989,5.526,5.526,0,0,1-1.454-2.167,14.543,14.543,0,0,1-.6-4.174,20.624,20.624,0,0,0-.48-3.737,6.907,6.907,0,0,1,.974,3.708,15.171,15.171,0,0,0,.727,3.97,4.843,4.843,0,0,0,1.251,1.876,2.908,2.908,0,0,0,2.138.8,2.225,2.225,0,0,0,1.92-1.251l1.207-3.01-.538,3.185a2.341,2.341,0,0,0,1.571,2.821,3.054,3.054,0,0,0,2.676-.974,8.814,8.814,0,0,0,1.265-1.672C499.555,221.591,499.715,221.373,499.745,221.387Z",
    transform: "translate(-306.494 -189.733)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5451",
    "data-name": "Path 5451",
    d: "M497.112,228.347A3.854,3.854,0,0,1,494.6,229a8.624,8.624,0,0,1-5.715-2.5,16.274,16.274,0,0,1-3.417-5.206,7.953,7.953,0,0,1-.843-2.414,10.733,10.733,0,0,1,1.294,2.2,20.067,20.067,0,0,0,3.461,4.915,9.017,9.017,0,0,0,5.25,2.5,19.171,19.171,0,0,0,2.487-.145Z",
    transform: "translate(-307.148 -186.862)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5452",
    "data-name": "Path 5452",
    d: "M496.663,228.839a4.741,4.741,0,0,1-2.21.16,12.027,12.027,0,0,1-5.075-1.716,11.822,11.822,0,0,1-3.839-3.752,4.363,4.363,0,0,1-.858-2.051,14.743,14.743,0,0,1,1.28,1.76,14.34,14.34,0,0,0,3.781,3.432,14.135,14.135,0,0,0,4.785,1.818A13.344,13.344,0,0,1,496.663,228.839Z",
    transform: "translate(-307.121 -185.681)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5453",
    "data-name": "Path 5453",
    d: "M501.347,203.85a14.37,14.37,0,0,1-2.24-.305,14.978,14.978,0,0,0-5.308.32,15.167,15.167,0,0,0-4.857,2.2c-1.12.785-1.745,1.454-1.832,1.323a5.163,5.163,0,0,1,1.527-1.731,12.869,12.869,0,0,1,4.988-2.487,12.463,12.463,0,0,1,5.555-.116A5.061,5.061,0,0,1,501.347,203.85Z",
    transform: "translate(-306.017 -194.17)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5454",
    "data-name": "Path 5454",
    d: "M489.121,198.17a11.329,11.329,0,0,1-1.861,11.91,27.775,27.775,0,0,0,1.934-5.817A26.885,26.885,0,0,0,489.121,198.17Z",
    transform: "translate(-305.949 -196.27)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5455",
    "data-name": "Path 5455",
    d: "M452.62,212.531a6.137,6.137,0,0,0,1.876,1.076,10.354,10.354,0,0,0,5.817-.684c1.193-.393,2.487-.916,3.9-1.454a24.91,24.91,0,0,0,4.261-2.007c2.909-1.658,5.817-4.028,9.409-5.643a16.434,16.434,0,0,1,5.584-1.454,10.3,10.3,0,0,1,5.279,1.091c3.068,1.6,5.235,3.81,7.562,4.726a7.518,7.518,0,0,0,5.715.262,6.138,6.138,0,0,0,1.731-1.265,2.8,2.8,0,0,1-.305.494,4.216,4.216,0,0,1-1.309,1.033,7.678,7.678,0,0,1-6.021,0c-2.487-.931-4.726-3.141-7.664-4.61a9.715,9.715,0,0,0-4.945-.989,16.3,16.3,0,0,0-5.337,1.454c-3.5,1.556-6.413,3.9-9.38,5.555a24.43,24.43,0,0,1-4.363,2.007c-1.454.494-2.7,1-3.927,1.367a10.179,10.179,0,0,1-6.035.465,3.941,3.941,0,0,1-1.454-.887,2.2,2.2,0,0,1-.393-.538Z",
    transform: "translate(-321.684 -194.372)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5456",
    "data-name": "Path 5456",
    d: "M497.068,208.765a44.534,44.534,0,0,0-3.447-3.49,20.548,20.548,0,0,0-10.645-4.639,35.669,35.669,0,0,0-6.5.073,36.55,36.55,0,0,1-5.41.116,11.853,11.853,0,0,1-3.577-.785,3.621,3.621,0,0,1-1.178-.64,17.975,17.975,0,0,0,4.785.916,42.69,42.69,0,0,0,5.337-.262,32,32,0,0,1,6.631-.131,19.836,19.836,0,0,1,10.892,4.974,17.783,17.783,0,0,1,2.429,2.719,4.36,4.36,0,0,1,.683,1.149Z",
    transform: "translate(-315.466 -195.711)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5457",
    "data-name": "Path 5457",
    d: "M468.71,237.744c0-.247,1.774-.451,3.287-1.861a10.033,10.033,0,0,0,1.643-2.094c.378-.6.654-.974.742-.916s0,.465-.291,1.149a6.385,6.385,0,0,1-1.6,2.385,5.425,5.425,0,0,1-2.574,1.338C469.132,237.889,468.725,237.831,468.71,237.744Z",
    transform: "translate(-314.375 -180.509)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5458",
    "data-name": "Path 5458",
    d: "M633.463,421.488l23.821-13.5S679,427.668,683.649,425.6l-24.519-47.1L621.16,398Z",
    transform: "translate(-245.124 -114.354)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10540",
    "data-name": "Group 10540",
    transform: "translate(402.495 277.619)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5459",
    "data-name": "Path 5459",
    d: "M639.392,390.288a2.182,2.182,0,0,1,1.454-2.472,2.094,2.094,0,0,1,2.472,1.454,2.268,2.268,0,0,1-1.571,2.618,2.152,2.152,0,0,1-2.385-1.8",
    transform: "translate(-639.354 -387.764)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10541",
    "data-name": "Group 10541",
    transform: "translate(410.254 264.146)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5460",
    "data-name": "Path 5460",
    d: "M648.442,378.5l-3.752,2.181,24.9,44.384s2.007,1.614,3.359.611Z",
    transform: "translate(-644.69 -378.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5461",
    "data-name": "Path 5461",
    d: "M646.4,401.153c.233-.116-.262-1.323-.116-2.836s.8-2.632.611-2.792-1.352.873-1.454,2.7S646.257,401.313,646.4,401.153Z",
    transform: "translate(-234.097 -106.627)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5462",
    "data-name": "Path 5462",
    d: "M649.431,403.578c.247,0,.116-1.265.683-2.545s1.454-2.051,1.352-2.269-1.454.305-2.181,1.92S649.2,403.695,649.431,403.578Z",
    transform: "translate(-232.501 -105.17)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5463",
    "data-name": "Path 5463",
    d: "M655.316,401.907c0-.247-1.367,0-2.327,1.28s-.887,2.589-.64,2.589.567-1.018,1.367-2.036S655.418,402.081,655.316,401.907Z",
    transform: "translate(-231.028 -103.76)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5464",
    "data-name": "Path 5464",
    d: "M642.941,402.672c.16-.218-.713-1.105-1.294-2.443s-.713-2.574-.974-2.589-.567,1.382.145,2.909S642.81,402.875,642.941,402.672Z",
    transform: "translate(-236.395 -105.659)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10542",
    "data-name": "Group 10542",
    transform: "translate(381.14 279.023)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5465",
    "data-name": "Path 5465",
    d: "M636.58,414.165l4.246-2.4L628.582,388.73l-3.912,1.992Z",
    transform: "translate(-624.67 -388.73)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5466",
    "data-name": "Path 5466",
    d: "M641.013,404.744a5.128,5.128,0,0,0-1.236-2.356,12.434,12.434,0,0,0-2.05-2.08,12.22,12.22,0,0,0-1.454-.974,2.985,2.985,0,0,0-.916-.422,1.134,1.134,0,0,0-1.28.523,1.454,1.454,0,0,0,0,1.28,3.1,3.1,0,0,0,.582.829,9.844,9.844,0,0,0,1.265,1.207,9.144,9.144,0,0,0,2.56,1.454,4.363,4.363,0,0,0,2.632.393c0-.145-.974-.305-2.385-.974a11.3,11.3,0,0,1-2.283-1.454,10.332,10.332,0,0,1-1.12-1.134c-.393-.422-.611-.843-.465-1.091s.1-.116.291-.087a3.01,3.01,0,0,1,.683.305,13.844,13.844,0,0,1,1.367.887,15.571,15.571,0,0,1,2.051,1.818C640.359,403.959,640.882,404.875,641.013,404.744Z",
    transform: "translate(-239.324 -105.099)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5467",
    "data-name": "Path 5467",
    d: "M641,402.588a4.174,4.174,0,0,0-2.6.567,8.871,8.871,0,0,0-2.414,1.658,8.728,8.728,0,0,0-1.12,1.352,2.2,2.2,0,0,0-.407,2.123,1.221,1.221,0,0,0,1.163.64,3.126,3.126,0,0,0,.989-.2,6.094,6.094,0,0,0,3.5-3.1,3.448,3.448,0,0,0,.436-2.632,24.234,24.234,0,0,1-.989,2.327,6.224,6.224,0,0,1-1.833,1.89,5.291,5.291,0,0,1-1.381.669c-.538.189-1.047.218-1.091,0a1.455,1.455,0,0,1,.349-1.236,8.316,8.316,0,0,1,.974-1.236,9.557,9.557,0,0,1,2.109-1.687C640.04,402.937,641.029,402.733,641,402.588Z",
    transform: "translate(-239.137 -103.423)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5468",
    "data-name": "Path 5468",
    d: "M584.068,443.4l27.005-4.435s13.583,25.973,18.644,25.639l-6.7-52.673-42.362,5.177Z",
    transform: "translate(-263.526 -99.168)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10543",
    "data-name": "Group 10543",
    transform: "translate(343.128 322.006)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5469",
    "data-name": "Path 5469",
    d: "M598.544,420.095a2.138,2.138,0,0,1,2.254-1.8,2.079,2.079,0,0,1,1.8,2.225,2.269,2.269,0,0,1-2.4,1.891,2.167,2.167,0,0,1-1.629-2.53",
    transform: "translate(-598.531 -418.287)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10544",
    "data-name": "Group 10544",
    transform: "translate(355.182 312.762)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5470",
    "data-name": "Path 5470",
    d: "M611.066,411.93l-4.246.684,8.013,50.317s1.323,2.21,2.909,1.745Z",
    transform: "translate(-606.82 -411.93)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5471",
    "data-name": "Path 5471",
    d: "M601.534,432.759c.262,0,.218-1.352.872-2.719s1.672-2.181,1.542-2.414-1.571.349-2.356,2.036S601.316,432.832,601.534,432.759Z",
    transform: "translate(-254.205 -92.061)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5472",
    "data-name": "Path 5472",
    d: "M603.538,435.953c.262,0,.553-1.134,1.454-2.152s2.094-1.454,2.051-1.658-1.454-.233-2.7,1.047S603.291,435.982,603.538,435.953Z",
    transform: "translate(-253.213 -90.034)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5473",
    "data-name": "Path 5473",
    d: "M609.6,436.374c0-.233-1.309-.436-2.632.407s-1.731,2.109-1.454,2.2.887-.756,1.978-1.454S609.617,436.635,609.6,436.374Z",
    transform: "translate(-252.268 -88.157)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5474",
    "data-name": "Path 5474",
    d: "M597.505,433.079c.233-.131-.276-1.265-.364-2.734s.233-2.661,0-2.763-1.018,1.091-.887,2.821S597.345,433.224,597.505,433.079Z",
    transform: "translate(-256.444 -92.061)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10545",
    "data-name": "Group 10545",
    transform: "translate(322.752 316.718)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5475",
    "data-name": "Path 5475",
    d: "M587.6,441.277l4.814-.771-3.534-25.857-4.363.509Z",
    transform: "translate(-584.52 -414.65)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5476",
    "data-name": "Path 5476",
    d: "M594.979,434.324a5.161,5.161,0,0,0-.349-2.647,12.546,12.546,0,0,0-1.207-2.647,13.866,13.866,0,0,0-.989-1.454,3.386,3.386,0,0,0-.727-.713,1.12,1.12,0,0,0-1.454,0,1.454,1.454,0,0,0-.451,1.207,3.924,3.924,0,0,0,.262.974,9.855,9.855,0,0,0,.771,1.571,9.962,9.962,0,0,0,1.905,2.225,4.6,4.6,0,0,0,2.341,1.28c0-.131-.8-.625-1.905-1.745a10.891,10.891,0,0,1-1.614-2.181,10.27,10.27,0,0,1-.669-1.454c-.218-.538-.276-1.018,0-1.193s.116-.073.305,0a3.1,3.1,0,0,1,.523.538,13.074,13.074,0,0,1,.974,1.294,14.768,14.768,0,0,1,1.294,2.414A19.565,19.565,0,0,0,594.979,434.324Z",
    transform: "translate(-259.372 -92.506)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5477",
    "data-name": "Path 5477",
    d: "M596.115,431.774a4.362,4.362,0,0,0-2.632-.363,8.727,8.727,0,0,0-2.909.727,9.419,9.419,0,0,0-1.454.872,2.21,2.21,0,0,0-1.12,1.847,1.236,1.236,0,0,0,.873,1.018,3.793,3.793,0,0,0,1,.145,6.411,6.411,0,0,0,1.789-.218,6.2,6.2,0,0,0,2.574-1.454c1.236-1.207,1.454-2.312,1.309-2.327a14.663,14.663,0,0,1-1.731,1.847,6.02,6.02,0,0,1-2.37,1.149,5.3,5.3,0,0,1-1.454.145c-.567,0-1.047-.16-1.018-.378a1.9,1.9,0,0,1,.742-1.033,7.864,7.864,0,0,1,1.352-.829,9.99,9.99,0,0,1,2.56-.858C595.1,431.774,596.1,431.919,596.115,431.774Z",
    transform: "translate(-260.187 -90.348)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5478",
    "data-name": "Path 5478",
    d: "M526.177,333.38c-.843.334,12.783,13.452,14.979,22.337,2.632,10.718,9.816,22.977,9.816,22.977l50.346,48.223,94.818-13.874,16,29.216-114.3,30.99a20.8,20.8,0,0,1-17.844-3.374L506.21,415.051,463.92,362.7Z",
    transform: "translate(-316.551 -134.85)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5479",
    "data-name": "Path 5479",
    d: "M459.1,361.958l6.108,22.454c17.131,35.4,49.765,102.423,58.4,106.742,12.012,6.006,122.492-16,122.492-16l-2.458-30.452-92.709,8.013L488.927,343.78Z",
    transform: "translate(-318.741 -130.126)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5480",
    "data-name": "Path 5480",
    d: "M697.345,428.331s-.2.087-.625.218l-1.862.567-7.169,2.094-26.438,7.562-39.265,11.14-23.108,6.6c-2.021.553-4.014,1.163-6.093,1.687a28.838,28.838,0,0,1-19.283-2.109,31.67,31.67,0,0,1-5.628-3.548l-5.148-4.043q-5.09-4.014-9.933-8c-6.428-5.323-12.579-10.529-18.309-15.633-11.518-10.18-21.523-19.72-29.667-27.994s-14.368-15.328-18.44-20.36l-2.69-3.374c-.713-1.018-1.338-1.876-1.832-2.574l-1.134-1.585c-.247-.364-.349-.553-.349-.553s.145.16.422.509.669.887,1.178,1.542,1.149,1.542,1.891,2.53l2.734,3.33c4.13,5,10.4,12,18.585,20.214s18.28,17.7,29.74,27.82c5.817,5.075,11.881,10.282,18.324,15.59,3.214,2.661,6.53,5.308,9.918,7.984l5.148,3.97a29.4,29.4,0,0,0,5.512,3.49,28.213,28.213,0,0,0,18.789,2.065c2.036-.509,4.072-1.134,6.079-1.687l23.181-6.544,39.265-10.98,26.482-7.359,7.271-1.963,1.891-.494Z",
    transform: "translate(-309.079 -118.928)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5481",
    "data-name": "Path 5481",
    d: "M480.8,357.365c.073.087-.611.407-.742,1.382a1.891,1.891,0,0,0,.422,1.454,1.672,1.672,0,0,0,2.734-1.193,1.862,1.862,0,0,0-.8-1.323c-.814-.567-1.454-.291-1.527-.407s.116-.16.436-.247a1.978,1.978,0,0,1,1.352.233,2.239,2.239,0,0,1,1.192,1.687,2.206,2.206,0,1,1-4.3-.349,1.993,1.993,0,0,1,.756-1.134C480.6,357.336,480.787,357.321,480.8,357.365Z",
    transform: "translate(-309.481 -124.122)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5482",
    "data-name": "Path 5482",
    d: "M522.517,348.232a4.362,4.362,0,0,1-.829.887,21.161,21.161,0,0,1-2.661,1.992,22.962,22.962,0,0,1-10.4,3.432,22.614,22.614,0,0,1-10.776-1.8,17.772,17.772,0,0,1-2.909-1.556,3.983,3.983,0,0,1-.974-.756c.073-.116,1.454.858,4.1,1.847a24.039,24.039,0,0,0,20.723-1.6C521.165,349.352,522.43,348.13,522.517,348.232Z",
    transform: "translate(-302.901 -128.106)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5483",
    "data-name": "Path 5483",
    d: "M629.916,312.285s-65.921-24.722-69.921-28.3-21.407-23.268-28.649-25.813c0,0-11.75-3.083-19.749-2.632l-8.449,1V250.13l-34.713.567-.96,8.551-5.919,2.24s-13.9,29.085-13.9,42.348-6.864,90.906,6.66,105.826c2.08,2.283,10.18.814,10.18.814s39.032-4.159,77.832-31.3l-14.208-16.419s-5-34.291.814-58.926c.131-.538.247-1.076.378-1.6,16.8,8.289,42.653,20.36,50.245,20.36,0,0,42.522,14.354,50.375,5.163C630.818,326.726,629.916,312.285,629.916,312.285Z",
    transform: "translate(-324.731 -172.667)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5484",
    "data-name": "Path 5484",
    d: "M487.693,257.06s-13.6.538-22.454,11.547-23.268,57.967-23.268,57.967l-19.836-20.36L403.23,316.7s26.729,37.258,31.994,41.577a28.214,28.214,0,0,0,9.656,4.115c12.7,1.105,21.276-11.823,23.879-22.483l8.726-43.817",
    transform: "translate(-344.12 -169.519)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5485",
    "data-name": "Path 5485",
    d: "M414.893,304.393l-20.36-12.085s-6.152-14.543-3.8-15.226,4.363,8.1,4.363,8.1l2.909,1.454s-3.97-7.388-2.589-8.086,3.316,1.454,4.363,3.156c.814,1.28,3.447,6.646,3.447,6.646l1.367-1.891-1.076-4.959s-1.454-3.316.16-3.345,1.614-.145,2.821,2.6,2.036,4.8,2.036,4.8,5.933,3.519,7.2,3.127a7.431,7.431,0,0,1,5.817.451s5.628,2.909,4.276,8.944",
    transform: "translate(-350.039 -160.441)",
    fill: "#f4d3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5486",
    "data-name": "Path 5486",
    d: "M502.937,258.37c.1,0-.436,1.454-1.091,3.665a40.72,40.72,0,0,0-1,18.135c.378,2.312.771,3.723.654,3.766a14.253,14.253,0,0,1-1.163-3.665,34.6,34.6,0,0,1-.727-9.264,34.206,34.206,0,0,1,1.76-9.118A13.99,13.99,0,0,1,502.937,258.37Z",
    transform: "translate(-300.365 -168.924)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5487",
    "data-name": "Path 5487",
    d: "M464.549,260.205a13.641,13.641,0,0,1-.364-4.944,13.468,13.468,0,0,1,.756-4.9,24.061,24.061,0,0,1,0,4.93A24.391,24.391,0,0,1,464.549,260.205Z",
    transform: "translate(-316.468 -172.562)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5488",
    "data-name": "Path 5488",
    d: "M470.04,261.448a21.389,21.389,0,0,1,.116-5.555A22.668,22.668,0,0,1,471,250.41a21.061,21.061,0,0,1-.131,5.555,22.271,22.271,0,0,1-.829,5.483Z",
    transform: "translate(-313.829 -172.539)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5489",
    "data-name": "Path 5489",
    d: "M477.455,261.136c-.2,0,.305-2.429.494-5.381s0-5.366.262-5.4a17.975,17.975,0,0,1-.756,10.776Z",
    transform: "translate(-310.424 -172.562)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5490",
    "data-name": "Path 5490",
    d: "M482.964,259.221c-.2,0,.116-2.051.073-4.523s-.422-4.465-.218-4.508a8.6,8.6,0,0,1,.931,4.494A9.032,9.032,0,0,1,482.964,259.221Z",
    transform: "translate(-307.994 -172.639)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5491",
    "data-name": "Path 5491",
    d: "M448.124,269.28c.189,0,0,18.993-.436,42.406s-.96,42.406-1.163,42.406,0-18.993.451-42.421S447.921,269.28,448.124,269.28Z",
    transform: "translate(-324.489 -163.968)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5492",
    "data-name": "Path 5492",
    d: "M453.146,302.159a18.028,18.028,0,0,1-2.908-1.614A40.1,40.1,0,0,0,443.286,297a17.669,17.669,0,0,0-7.591-1.105c-1.978.175-3.141.684-3.185.567a6.98,6.98,0,0,1,3.127-1.076,16.229,16.229,0,0,1,7.9.945,31.22,31.22,0,0,1,6.981,3.8,12.9,12.9,0,0,1,2.632,2.036Z",
    transform: "translate(-330.819 -152.171)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5493",
    "data-name": "Path 5493",
    d: "M525.426,290.83a4.966,4.966,0,0,1-.683.436l-2.007,1.178c-.873.509-1.963,1.105-3.258,1.731s-2.734,1.454-4.363,2.094-3.461,1.527-5.468,2.254-4.145,1.454-6.413,2.21a116.432,116.432,0,0,1-15.153,3.5,118.077,118.077,0,0,1-15.5,1.28c-2.4,0-4.668,0-6.791-.16s-4.1-.291-5.9-.48-3.4-.451-4.828-.669-2.632-.436-3.621-.654l-2.269-.509a3.044,3.044,0,0,1-.785-.218,3.1,3.1,0,0,1,.814.073l2.3.378c.989.175,2.2.378,3.621.538s3.025.436,4.828.553,3.752.335,5.817.393,4.363.087,6.748.087a112.82,112.82,0,0,0,30.539-4.741c2.269-.727,4.436-1.367,6.4-2.138s3.825-1.454,5.483-2.167,3.127-1.454,4.363-1.992,2.4-1.149,3.3-1.614l2.065-1.047A2.911,2.911,0,0,1,525.426,290.83Z",
    transform: "translate(-323.611 -154.178)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5494",
    "data-name": "Path 5494",
    d: "M532.291,276.352c.073.1-1.163.916-2.909,2.472a37.651,37.651,0,0,0-6.2,6.806,38.815,38.815,0,0,0-4.363,8.144c-.843,2.21-1.207,3.65-1.323,3.621a3.23,3.23,0,0,1,.116-1.033,22.822,22.822,0,0,1,.727-2.763,31.993,31.993,0,0,1,10.674-15.168,18.787,18.787,0,0,1,2.341-1.614C531.942,276.469,532.262,276.309,532.291,276.352Z",
    transform: "translate(-292.213 -160.758)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5495",
    "data-name": "Path 5495",
    d: "M538.174,277.91c0,.116-1.454.785-3.592,2.2a31.863,31.863,0,0,0-12.4,15.488c-.916,2.429-1.236,4.014-1.352,3.985s0-.407.1-1.134a20.8,20.8,0,0,1,.771-3.01,28.954,28.954,0,0,1,12.609-15.764,21.3,21.3,0,0,1,2.777-1.454A3.576,3.576,0,0,1,538.174,277.91Z",
    transform: "translate(-290.724 -160.047)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5496",
    "data-name": "Path 5496",
    d: "M526.123,286.72a3.3,3.3,0,0,1-.742.349l-2.138.873c-.931.378-2.08.829-3.432,1.28s-2.909,1.047-4.61,1.556c-3.432,1.105-7.577,2.225-12.216,3.287a148.653,148.653,0,0,1-15.27,2.589,153.3,153.3,0,0,1-15.459.989c-4.755.087-9.06-.116-12.652-.407-1.789-.1-3.4-.305-4.828-.451s-2.647-.305-3.636-.465l-2.3-.349a2.908,2.908,0,0,1-.843-.116,3.128,3.128,0,0,1,.814,0l2.3.218c1,.116,2.225.247,3.65.349s3.025.276,4.828.334c3.577.233,7.853.32,12.594.247s9.947-.422,15.386-1.033,10.572-1.542,15.211-2.516,8.726-2.094,12.216-3.127c1.73-.48,3.257-1.018,4.625-1.454s2.516-.829,3.461-1.163l2.2-.742a3.211,3.211,0,0,1,.844-.247Z",
    transform: "translate(-323.783 -156.045)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5497",
    "data-name": "Path 5497",
    d: "M452.288,294.421a52.474,52.474,0,0,0-7.751-4.2A53.328,53.328,0,0,0,436,288.037a7.343,7.343,0,0,1,2.632,0,24.225,24.225,0,0,1,6.181,1.454,23.689,23.689,0,0,1,5.555,3.083A6.922,6.922,0,0,1,452.288,294.421Z",
    transform: "translate(-329.234 -155.501)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5498",
    "data-name": "Path 5498",
    d: "M594.128,289.11l-14.4,4.828-7.271.64v15.5l7.475,2.545,20.054-1.091S611.478,317.352,614.4,317s2.908-1.251,2.908-1.251L603.1,307.157a8.144,8.144,0,0,1,5.468.727c3.272,1.454,8.929,4.741,10.936,3.839s1.643-1.643,1.643-1.643l-11.125-7.01s9.525,4.276,11.154,3.548a2.908,2.908,0,0,0,1.789-2.152l-6.2-5.512-9.307-7.271Z",
    transform: "translate(-267.246 -154.96)",
    fill: "#f4d3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5499",
    "data-name": "Path 5499",
    d: "M584.359,293.5a7.426,7.426,0,0,1,1.571.654c.974.451,2.385,1.134,4.116,2.007s3.781,1.905,6.035,3.185a5.1,5.1,0,0,1,1.614,1.28,3.825,3.825,0,0,1,.858,2.051,3.548,3.548,0,0,1-.495,2.269,3.329,3.329,0,0,1-2.007,1.294,6.733,6.733,0,0,1-3.185,0,22.981,22.981,0,0,1-2.778-1c-1.745-.727-3.345-1.454-4.8-2.225l.378-.087a8.579,8.579,0,0,1-3.345,2.661,7.532,7.532,0,0,1-3.228.611,7.664,7.664,0,0,1-2.065-.349c-.451-.145-.683-.276-.669-.305a14.963,14.963,0,0,0,2.749.305,7.736,7.736,0,0,0,3.01-.713,8.391,8.391,0,0,0,3.068-2.574l.145-.2.218.116c1.454.684,3.068,1.454,4.8,2.138a22.586,22.586,0,0,0,2.69.945,6.369,6.369,0,0,0,2.821,0,2.734,2.734,0,0,0,1.6-1,2.909,2.909,0,0,0,.393-1.8,3.665,3.665,0,0,0-2.123-2.836c-2.181-1.294-4.232-2.37-5.919-3.3L585.8,294.4A7.275,7.275,0,0,1,584.359,293.5Z",
    transform: "translate(-265.475 -152.966)",
    fill: "#eaae94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5500",
    "data-name": "Path 5500",
    d: "M602.774,300.562a27.964,27.964,0,0,1-6.37-3.956,14.043,14.043,0,0,1-1.294-1.12h.436a9.031,9.031,0,0,1-4.028,1.091,3.169,3.169,0,0,1-1.658-.16c0-.1.611-.116,1.614-.291a10.834,10.834,0,0,0,3.752-1.236l.247-.16.2.2c.364.349.8.7,1.236,1.062A65.753,65.753,0,0,1,602.774,300.562Z",
    transform: "translate(-259.342 -152.407)",
    fill: "#eaae94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5501",
    "data-name": "Path 5501",
    d: "M698.5,416.9a29.8,29.8,0,0,1-8.58-1.236c-27.631-8.275-26.177-28.213-25.057-44.238,1.076-14.935,1.12-24.33-11.2-28.954-16.3-6.108-23.006-.174-33.172,8.813-12.1,10.7-27.136,24.024-63.638,18.615-18.905-2.807-49.445-12.8-86.834-44.471a298.544,298.544,0,0,1-36.836-36.938l5.642-4.537c.567.7,56.4,69.5,119.089,78.777,33.157,4.915,46.231-6.66,57.778-16.869,10.354-9.162,20.127-17.815,40.516-10.18,18,6.762,16.884,22.425,15.88,36.255-1.163,16.186-2.167,30.161,19.909,36.778,24.868,7.446,57.574-31.994,77.076-55.494,6.98-8.391,11.823-14.47,15.691-17.626l5.468,4.363c-2.414,2.909-9.133,10.18-15.59,17.9C754.784,381.836,725.67,416.9,698.5,416.9Z",
    transform: "translate(-330.511 -157.304)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5502",
    "data-name": "Path 5502",
    d: "M553.307,336.008a5.971,5.971,0,0,1-.873.64,22.257,22.257,0,0,1-2.545,1.454,39.016,39.016,0,0,1-9.147,3.141,38.407,38.407,0,0,1-9.627.742,28.01,28.01,0,0,1-2.909-.305,3.666,3.666,0,0,1-1.047-.247,35.933,35.933,0,0,1,3.985,0,45.592,45.592,0,0,0,18.542-3.839C551.911,336.575,553.249,335.833,553.307,336.008Z",
    transform: "translate(-287.824 -133.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5503",
    "data-name": "Path 5503",
    d: "M578.954,321.111a16.082,16.082,0,0,1-2.37-.087,16.288,16.288,0,0,0-10.456,3.607,16.12,16.12,0,0,1-1.818,1.527,5.338,5.338,0,0,1,1.454-1.905,13.889,13.889,0,0,1,10.82-3.723,5.28,5.28,0,0,1,2.37.582Z",
    transform: "translate(-270.949 -140.715)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5504",
    "data-name": "Path 5504",
    d: "M610.918,373.21a9.569,9.569,0,0,1-3.272-1,21.116,21.116,0,0,1-10.994-11.9,9.688,9.688,0,0,1-.742-3.33c.116,0,.407,1.236,1.221,3.141a23.978,23.978,0,0,0,4.363,6.748,23.558,23.558,0,0,0,6.384,4.872C609.711,372.7,610.962,373.093,610.918,373.21Z",
    transform: "translate(-256.594 -124.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5505",
    "data-name": "Path 5505",
    d: "M679.44,321.27a88.712,88.712,0,0,1-11.46,11.43,93.85,93.85,0,0,1,11.46-11.43Z",
    transform: "translate(-223.856 -140.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5506",
    "data-name": "Path 5506",
    d: "M445.277,295.493h0a8.362,8.362,0,0,1-11.809.567L420.7,284.426l11.256-12.376,12.754,11.634A8.362,8.362,0,0,1,445.277,295.493Z",
    transform: "translate(-336.184 -162.709)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5507",
    "data-name": "Path 5507",
    d: "M445.427,295.643a20.6,20.6,0,0,0,1.178-1.949A8.246,8.246,0,0,0,447,287.63a8.144,8.144,0,0,0-2.312-3.592l-3.854-3.447c-2.719-2.472-5.744-5.192-8.958-8.086h.494l-5.628,6.2-5.628,6.181v-.494l8.9,8.1,3.81,3.5a8.188,8.188,0,0,0,3.781,1.963,8.275,8.275,0,0,0,6.006-.974,19.5,19.5,0,0,0,1.832-1.367,6.327,6.327,0,0,1-1.7,1.57,8.319,8.319,0,0,1-6.224,1.207,8.6,8.6,0,0,1-4.057-2.007c-1.207-1.076-2.487-2.24-3.854-3.447l-8.973-8.1-.262-.233.247-.262,5.613-6.2,5.628-6.166.233-.262.262.233,8.9,8.158,3.81,3.5a8.493,8.493,0,0,1,2.385,3.854,8.333,8.333,0,0,1-.611,6.3,6.078,6.078,0,0,1-1.411,1.876Z",
    transform: "translate(-336.334 -162.859)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5508",
    "data-name": "Path 5508",
    d: "M400.577,248.062,378.56,229.855a4.057,4.057,0,0,1-.538-5.715h0a4.057,4.057,0,0,1,5.715-.538l22,18.207Z",
    transform: "translate(-355.995 -185.141)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5509",
    "data-name": "Path 5509",
    d: "M386.331,266.354l-21.988-18.207a4.057,4.057,0,0,1-.553-5.715h0a4.043,4.043,0,0,1,5.715-.538l22.017,18.193Z",
    transform: "translate(-362.457 -176.835)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10546",
    "data-name": "Group 10546",
    transform: "translate(21.093 37.527)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5510",
    "data-name": "Path 5510",
    d: "M400.577,248.062,378.56,229.855a4.057,4.057,0,0,1-.538-5.715h0a4.057,4.057,0,0,1,5.715-.538l22,18.207Z",
    transform: "translate(-377.088 -222.668)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10547",
    "data-name": "Group 10547",
    transform: "translate(0.405 64.119)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5511",
    "data-name": "Path 5511",
    d: "M386.331,266.354l-21.988-18.207a4.057,4.057,0,0,1-.553-5.715h0a4.043,4.043,0,0,1,5.715-.538l22.017,18.193Z",
    transform: "translate(-362.862 -240.954)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5512",
    "data-name": "Path 5512",
    d: "M400.729,248.251a4.382,4.382,0,0,1,.335-.48l.989-1.28,3.679-4.639v.305l-10.34-8.406-6.471-5.323-3.476-2.909-1.789-1.454a3.577,3.577,0,0,0-1.934-.844,3.679,3.679,0,0,0-3.258,1.251,3.738,3.738,0,0,0-.785,3.316,3.432,3.432,0,0,0,.785,1.454,11.8,11.8,0,0,0,1.323,1.193l2.734,2.269,9.424,7.926,6.384,5.439,1.745,1.454a5.912,5.912,0,0,1,.625.582,3.839,3.839,0,0,1-.611-.436l-1.745-1.454c-1.614-1.294-3.825-3.054-6.5-5.221l-9.685-7.868-2.792-2.283a15.989,15.989,0,0,1-1.454-1.265,4.363,4.363,0,0,1,3.883-7.271,4.537,4.537,0,0,1,2.312,1l1.774,1.454,3.461,2.909,6.442,5.366,10.18,8.566.174.145-.145.16-3.941,4.6-1.047,1.163a2.576,2.576,0,0,1-.276.582Z",
    transform: "translate(-356.148 -185.33)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5513",
    "data-name": "Path 5513",
    d: "M386.457,266.49a2.779,2.779,0,0,1,.349-.48c.262-.349.582-.771.989-1.28l3.679-4.639v.305l-10.34-8.42-6.471-5.308-3.476-2.909-1.789-1.454a3.81,3.81,0,0,0-1.949-.843,3.723,3.723,0,0,0-3.258,1.265,3.679,3.679,0,0,0-.771,3.316,3.49,3.49,0,0,0,.771,1.454,11.906,11.906,0,0,0,1.338,1.178l2.719,2.283,9.438,7.926,6.384,5.439,1.745,1.454a3.821,3.821,0,0,1,.611.582s-.2-.131-.6-.436l-1.76-1.382-6.5-5.221-9.671-7.868-2.792-2.3a12.463,12.463,0,0,1-1.454-1.265,4.2,4.2,0,0,1-.931-1.8,4.363,4.363,0,0,1,.916-3.941,4.45,4.45,0,0,1,3.883-1.454,4.552,4.552,0,0,1,2.312,1c.6.509,1.192.989,1.789,1.454l3.461,2.909,6.442,5.352,10.18,8.58.16.145-.131.16c-1.658,1.905-2.981,3.447-3.956,4.581l-1.033,1.178A1.067,1.067,0,0,1,386.457,266.49Z",
    transform: "translate(-362.584 -176.97)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5514",
    "data-name": "Path 5514",
    d: "M452.42,268.06l.582-.7a7.78,7.78,0,0,0-10.82-11.067L409.955,229.45,373.09,273.558l32.982,26.177a7.78,7.78,0,0,0,1.585,10.18h0a7.766,7.766,0,0,0,10.82-.9,22.41,22.41,0,0,0,30.99-3.883l5.294-6.6a22.425,22.425,0,0,0-2.341-30.467Z",
    transform: "translate(-357.811 -182.061)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5515",
    "data-name": "Path 5515",
    d: "M452.579,268.219l.276.247.771.742a10.7,10.7,0,0,1,1.178,1.28l.713.873.727,1.062a21.263,21.263,0,0,1,2.909,6.064,22.41,22.41,0,0,1-3.243,19.385c-1.178,1.672-2.545,3.258-3.883,4.988a42.548,42.548,0,0,1-4.465,5.133,22.381,22.381,0,0,1-13.466,5.962,22.758,22.758,0,0,1-15.6-4.45h.451a8.2,8.2,0,0,1-5.308,2.749,8.057,8.057,0,0,1-5.977-1.8h0A8.144,8.144,0,0,1,406,299.806l.073.451-25.58-20.4-7.46-5.933-.291-.218.233-.291c13.437-16,25.988-31.034,36.909-44.064l.2-.247.233.2,32.154,26.918h-.247a7.926,7.926,0,0,1,12.826,6.326,7.678,7.678,0,0,1-1.454,4.363,9.7,9.7,0,0,1-.756.916l-.276.305s.349-.436.945-1.28a7.867,7.867,0,0,0,1.309-4.363,7.678,7.678,0,0,0-3.243-6.239,7.46,7.46,0,0,0-4.363-1.454,7.606,7.606,0,0,0-4.814,1.643l-.131.1-.131-.1-32.284-26.758h.436l-36.764,44.209v-.509l7.446,5.933,25.522,20.36.247.189-.174.262a7.46,7.46,0,0,0,1.454,9.758h0a7.446,7.446,0,0,0,10.369-.858l.2-.218.233.174a22.163,22.163,0,0,0,28.314-1.5,43.357,43.357,0,0,0,4.363-5.061c1.352-1.716,2.749-3.316,3.912-4.945a22.308,22.308,0,0,0,.611-25.057c-.247-.378-.48-.742-.713-1.076l-.7-.873a13.372,13.372,0,0,0-1.134-1.338l-.742-.771Q452.564,268.219,452.579,268.219Z",
    transform: "translate(-357.97 -182.22)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17829",
    "data-name": "Rectangle 17829",
    width: 29.507,
    height: 5.773,
    transform: "matrix(0.771, 0.637, -0.637, 0.771, 34.973, 68.041)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5516",
    "data-name": "Path 5516",
    d: "M438.3,256a12.422,12.422,0,0,1-1.222,1.716c-.814,1.091-2.021,2.632-3.534,4.523-3.01,3.8-7.271,8.958-12.027,14.615s-8.987,10.674-12.2,14.47l-3.694,4.363a11.632,11.632,0,0,1-1.454,1.542,12.423,12.423,0,0,1,1.222-1.716c.814-1.091,2.021-2.632,3.534-4.523,3.01-3.8,7.271-8.958,12.027-14.543l12.2-14.543,3.708-4.363A11.155,11.155,0,0,1,438.3,256Z",
    transform: "translate(-343.693 -170)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5517",
    "data-name": "Path 5517",
    d: "M432.047,247.87a12.2,12.2,0,0,1-1.309,1.8c-.887,1.134-2.2,2.763-3.81,4.755-3.258,3.985-7.824,9.424-12.914,15.386s-9.656,11.256-13.088,15.255c-1.629,1.861-2.909,3.418-3.985,4.6a13.723,13.723,0,0,1-1.541,1.629,15.163,15.163,0,0,1,1.323-1.8c.887-1.134,2.181-2.763,3.81-4.755,3.258-3.985,7.824-9.424,12.914-15.386l13.088-15.241,3.985-4.61A14.547,14.547,0,0,1,432.047,247.87Z",
    transform: "translate(-347.677 -173.693)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-65",
    transform: "translate(60.393 146.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5518",
    "data-name": "Path 5518",
    d: "M326.169,167.507c-.2.48-16.244,12.667-16.244,12.667l-.305,10.354,8.289,1.163L329.689,185l7.984-.407s4.872,2.574,5.817,2.909a2.821,2.821,0,0,0,3.272-1.352l-7.271-5.293s8.057,4.494,8.827,3.9a2.5,2.5,0,0,0-.771-3.883s2.5,1.323,4.086.262,1.018-2.327,1.018-2.327l-10.645-9.554a7.271,7.271,0,0,0-4.959-1.861Z",
    transform: "translate(58.685 -83.868)",
    fill: "#b78876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5519",
    "data-name": "Path 5519",
    d: "M327.431,170.56a6.993,6.993,0,0,1-.116,1.236c-.145.9-.32,2.036-.538,3.4l-.2-.247,6.122-.407a7.882,7.882,0,0,1,3.883.524,3.708,3.708,0,0,1,1.6,1.571,2.647,2.647,0,0,1,.1,2.37v.087h-.087c-1.934,1.149-4.363.887-6.471,1.033a7.519,7.519,0,0,0-4.508,1.643,29.767,29.767,0,0,0-3.359,3.258,15.065,15.065,0,0,1-3.345,2.821,7.489,7.489,0,0,1-3.694,1.033,14.543,14.543,0,0,1-5.352-1.12,8.826,8.826,0,0,1-1.8-.829,12.157,12.157,0,0,1,1.905.553,15.43,15.43,0,0,0,5.235.887,7.14,7.14,0,0,0,3.4-1.033,14.95,14.95,0,0,0,3.17-2.763,29.8,29.8,0,0,1,3.4-3.359,8.217,8.217,0,0,1,4.9-1.8c2.254-.131,4.494.073,6.166-.916l-.145.145a2.516,2.516,0,0,0-1.367-3.054,7.155,7.155,0,0,0-3.563-.509l-6.137.233h-.262v-.247c.291-1.352.538-2.472.727-3.374A4.593,4.593,0,0,1,327.431,170.56Z",
    transform: "translate(58.703 -82.428)",
    fill: "#aa6550"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5520",
    "data-name": "Path 5520",
    d: "M341.887,179.318a7.271,7.271,0,0,1-2.734-1.614c-1.571-1.207-3.287-3.316-5.628-5.017a3.97,3.97,0,0,0-1.8-.756,17.678,17.678,0,0,0-1.963,0h-3.418a14.283,14.283,0,0,1-3.141-.2,12.941,12.941,0,0,1,3.141-.305l3.4-.131a16,16,0,0,1,2.051,0,4.363,4.363,0,0,1,2.138.873,58.5,58.5,0,0,1,5.541,5.221C340.884,178.634,341.945,179.216,341.887,179.318Z",
    transform: "translate(64.854 -82.111)",
    fill: "#aa6550"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5521",
    "data-name": "Path 5521",
    d: "M344.26,388.47l-.393,25.493s25.726,8.944,26.1,13.655l-49.343,1-1.018-39.658Z",
    transform: "translate(63.223 16.559)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10548",
    "data-name": "Group 10548",
    transform: "translate(390.394 428.589)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5522",
    "data-name": "Path 5522",
    d: "M326.192,404.728a2.007,2.007,0,0,0-1.338,2.327,1.934,1.934,0,0,0,2.3,1.352,2.123,2.123,0,0,0,1.454-2.472,2.021,2.021,0,0,0-2.545-1.149",
    transform: "translate(-324.809 -404.671)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10549",
    "data-name": "Group 10549",
    transform: "translate(383.851 441.065)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5523",
    "data-name": "Path 5523",
    d: "M320.31,417.249v-4l47.307.538s2.21.9,1.992,2.458Z",
    transform: "translate(-320.31 -413.25)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5524",
    "data-name": "Path 5524",
    d: "M338.218,405.846c0,.233-1.193.378-2.37,1.178s-1.774,1.818-2.007,1.731.116-1.454,1.542-2.429S338.276,405.628,338.218,405.846Z",
    transform: "translate(69.657 24.356)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5525",
    "data-name": "Path 5525",
    d: "M341.424,407.213c.073.233-.974.654-1.774,1.7s-1,2.109-1.251,2.109-.422-1.367.6-2.632S341.424,406.951,341.424,407.213Z",
    transform: "translate(71.672 25.025)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5526",
    "data-name": "Path 5526",
    d: "M342.626,412.712c-.218,0-.567-1.149,0-2.472s1.716-1.891,1.818-1.687-.582.916-1.047,2.021S342.873,412.683,342.626,412.712Z",
    transform: "translate(73.538 25.663)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5527",
    "data-name": "Path 5527",
    d: "M338.048,402.057c-.087.218-1.207-.1-2.56,0s-2.414.567-2.545.364.873-1.091,2.472-1.207S338.164,401.854,338.048,402.057Z",
    transform: "translate(69.275 22.342)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10550",
    "data-name": "Group 10550",
    transform: "translate(382.949 410.06)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5528",
    "data-name": "Path 5528",
    d: "M344.136,391.93l-.058,4.537-24.272.276-.116-4.086Z",
    transform: "translate(-319.69 -391.93)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5529",
    "data-name": "Path 5529",
    d: "M338.808,399.473a4.814,4.814,0,0,1-2.472,0,11.4,11.4,0,0,1-2.6-.742,11.982,11.982,0,0,1-1.454-.727,2.5,2.5,0,0,1-.756-.567,1.062,1.062,0,0,1-.145-1.28,1.353,1.353,0,0,1,1.047-.567,3.025,3.025,0,0,1,.931.116,7.968,7.968,0,0,1,1.542.494,8.726,8.726,0,0,1,2.312,1.454c1.163,1.047,1.585,1.934,1.454,1.978s-.684-.654-1.861-1.454a9.735,9.735,0,0,0-2.24-1.193,8.155,8.155,0,0,0-1.454-.407c-.524-.131-.96-.116-1.091.116s0,.116,0,.276a3.2,3.2,0,0,0,.553.407c.451.276.887.509,1.323.727a13.174,13.174,0,0,0,2.414.858,15.877,15.877,0,0,1,2.5.509Z",
    transform: "translate(68.5 19.793)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5530",
    "data-name": "Path 5530",
    d: "M336.454,400.944a3.941,3.941,0,0,1-.7-2.385,7.985,7.985,0,0,1,.276-2.7,8.231,8.231,0,0,1,.611-1.454,2.007,2.007,0,0,1,1.542-1.28,1.134,1.134,0,0,1,1.047.669,2.91,2.91,0,0,1,.276.9,5.311,5.311,0,0,1,0,1.658,5.527,5.527,0,0,1-1,2.574c-.931,1.309-1.934,1.614-1.949,1.527a10.1,10.1,0,0,0,1.454-1.847,5.817,5.817,0,0,0,.742-2.341,5.337,5.337,0,0,0-.087-1.454c-.087-.524-.291-.931-.48-.887a1.811,1.811,0,0,0-.858.829,9.715,9.715,0,0,0-.582,1.352,8.727,8.727,0,0,0-.422,2.487C336.309,400,336.585,400.9,336.454,400.944Z",
    transform: "translate(70.549 18.671)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5531",
    "data-name": "Path 5531",
    d: "M274.8,294.826c1.207,1.818,54.782,57.4,54.782,57.4s-6.66,25.609-4.261,47.874,9.627,57.748,9.627,57.748l38.843-3.1-10.572-120.7L320.813,278Z",
    transform: "translate(42.868 -33.623)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5532",
    "data-name": "Path 5532",
    d: "M353.3,369.13l4.77,25s27.006,3.548,28.343,8.086l-48.136,10.98-9.016-38.64Z",
    transform: "translate(67.606 7.773)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10551",
    "data-name": "Group 10551",
    transform: "translate(409.302 403.015)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5533",
    "data-name": "Path 5533",
    d: "M338.827,387.281a2.007,2.007,0,0,0-.843,2.559,1.934,1.934,0,0,0,2.516.858,2.123,2.123,0,0,0,.887-2.705,1.992,1.992,0,0,0-2.72-.611",
    transform: "translate(-337.811 -387.085)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10552",
    "data-name": "Group 10552",
    transform: "translate(405.127 407.981)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5534",
    "data-name": "Path 5534",
    d: "M335.7,403.486l-.756-3.926,46.434-9.06s2.356.436,2.458,2.007Z",
    transform: "translate(-334.94 -390.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5535",
    "data-name": "Path 5535",
    d: "M350.759,386.03c0,.233-1.105.611-2.094,1.629s-1.367,2.152-1.6,2.109-.2-1.454,1-2.7S350.759,385.841,350.759,386.03Z",
    transform: "translate(75.643 15.406)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5536",
    "data-name": "Path 5536",
    d: "M354.187,386.687c.1.218-.829.858-1.454,2.021s-.567,2.283-.8,2.327-.684-1.251,0-2.7S354.129,386.469,354.187,386.687Z",
    transform: "translate(77.741 15.724)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5537",
    "data-name": "Path 5537",
    d: "M356.471,391.777c-.2.1-.8-1-.494-2.429s1.294-2.181,1.454-2.021-.378,1.018-.611,2.2S356.689,391.689,356.471,391.777Z",
    transform: "translate(79.704 16.03)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5538",
    "data-name": "Path 5538",
    d: "M349.937,382.337c0,.233-1.207.145-2.516.553s-2.24,1.047-2.414.873.64-1.251,2.181-1.687S350.01,382.119,349.937,382.337Z",
    transform: "translate(74.749 13.573)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10553",
    "data-name": "Group 10553",
    transform: "translate(398.059 381.862)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5539",
    "data-name": "Path 5539",
    d: "M353.872,372.54l.858,4.45-23.7,5.192-.945-3.985Z",
    transform: "translate(-330.08 -372.54)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5540",
    "data-name": "Path 5540",
    d: "M350.152,379.541a4.6,4.6,0,0,1-2.414.538,11.954,11.954,0,0,1-4.246-.611,3.215,3.215,0,0,1-.858-.407,1.033,1.033,0,0,1-.393-1.222,1.309,1.309,0,0,1,.9-.771,3.214,3.214,0,0,1,.945-.087,9.624,9.624,0,0,1,1.614.174,8.622,8.622,0,0,1,2.545.945c1.352.785,1.934,1.571,1.876,1.643s-.8-.509-2.138-1.105a9.8,9.8,0,0,0-2.429-.727,8.1,8.1,0,0,0-1.454-.1c-.538,0-.974.073-1.047.334s0,.131.116.247a2.282,2.282,0,0,0,.625.291,10.048,10.048,0,0,0,1.454.436,12.6,12.6,0,0,0,2.53.364,16.641,16.641,0,0,1,2.37.058Z",
    transform: "translate(73.473 11.338)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5541",
    "data-name": "Path 5541",
    d: "M347.969,381.528a4.156,4.156,0,0,1-1.178-2.181,8.552,8.552,0,0,1-.276-2.719,8.271,8.271,0,0,1,.291-1.6,2.05,2.05,0,0,1,1.251-1.571,1.163,1.163,0,0,1,1.163.451,3.126,3.126,0,0,1,.451.829,5.525,5.525,0,0,1,.378,1.614,5.816,5.816,0,0,1-.465,2.734c-.654,1.454-1.571,1.963-1.614,1.891a19.953,19.953,0,0,0,1.062-2.109,5.891,5.891,0,0,0,.247-2.443,5.394,5.394,0,0,0-.364-1.382c-.189-.494-.48-.858-.654-.771a1.8,1.8,0,0,0-.669.989,8.217,8.217,0,0,0-.218,3.956C347.634,380.67,348.085,381.528,347.969,381.528Z",
    transform: "translate(75.438 9.729)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5542",
    "data-name": "Path 5542",
    d: "M209.03,269.552s-3.592,22.992,10.34,38.029,28.954,21.654,55.422,20.461,83.605.131,83.605.131,2.414,30.539,9.031,55.509,19.822,62.533,19.822,62.533l25.886-2.472s-6.995-136.089-8.8-148.116-21.814-18.12-32.706-21.727-72.945-16.07-72.945-16.07L242.3,249.92Z",
    transform: "translate(12.802 -46.378)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5543",
    "data-name": "Path 5543",
    d: "M400.754,419.7H400.3l-1.352.1-5.264.378-19.822,1.309h-.174v-.174c-3.476-11.14-7.984-25.609-13.2-42.3-2.6-8.362-5.366-17.291-8.275-26.627-1.454-4.654-3.01-9.438-4.072-14.441a97.436,97.436,0,0,1-2.167-15.415,73.686,73.686,0,0,1,.974-18.178l.335.436c-15.779-.32-30.641-.48-44.049-.523-6.7,0-13.088,0-18.905.1s-11.4.305-16.419.305c-10.005,0-18.018-.509-23.53-.989-2.749-.233-4.886-.465-6.311-.625l-1.643-.218-.553-.087a3.327,3.327,0,0,1,.567,0l1.629.145,6.326.509c5.512.393,13.525.843,23.515.756,4.988,0,10.485-.291,16.4-.393s12.274-.16,18.905-.16c13.423,0,28.285.131,44.064.451h.422l-.087.436a73.831,73.831,0,0,0-.945,17.96,97.825,97.825,0,0,0,2.138,15.313c1.076,4.959,2.618,9.7,4.057,14.368,2.909,9.351,5.628,18.28,8.217,26.642,5.134,16.739,9.584,31.223,13.016,42.392l-.218-.16,19.836-1.105,5.264-.262h1.352a2.279,2.279,0,0,1,.422.058Z",
    transform: "translate(25.184 -22.388)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5544",
    "data-name": "Path 5544",
    d: "M324.729,293c.145.145-3.068,3.258-6.355,7.635s-5.381,8.333-5.584,8.231a10.643,10.643,0,0,1,1.192-2.69,45.086,45.086,0,0,1,3.825-5.962,46.223,46.223,0,0,1,4.668-5.337A9.232,9.232,0,0,1,324.729,293Z",
    transform: "translate(60.125 -26.809)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5545",
    "data-name": "Path 5545",
    d: "M331.663,294.68a56.71,56.71,0,0,0-10.18,5.206,57.906,57.906,0,0,0-8.493,7.737,12.286,12.286,0,0,1,1.963-2.792,31.993,31.993,0,0,1,13.466-9.307A11.269,11.269,0,0,1,331.663,294.68Z",
    transform: "translate(60.216 -26.046)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5546",
    "data-name": "Path 5546",
    d: "M246.39,168.49c1.905.945,41.621,25.231,43.511,25.231s48.878-17.146,48.878-17.146l9.627,14.863s-41.2,31.732-54.695,32.2-34.9-10.369-34.9-10.369Z",
    transform: "translate(29.962 -83.369)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5547",
    "data-name": "Path 5547",
    d: "M204.821,177.748S155.391,228.007,156,240.775s6.748,19.822,10.674,21.479c5.483,2.327,67.376-5.293,67.376-5.293l3.665-24.082c-10.18-2.021-23.079-3.548-37.054-4.886,6.268-6.559,13.234-11.532,21.814-12.987l14.8-16.1S218.782,174.606,204.821,177.748Z",
    transform: "translate(-11.1 -79.291)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5548",
    "data-name": "Path 5548",
    d: "M187.976,199.474s-2.37-10.849,2.909-15.2c8.726-7.271,16.171-10.572,22.512-13.728,7.271-3.621,14.964-7.809,14.964-7.809l44.864,8.347s23.952,38.247,23.443,47.656a24.97,24.97,0,0,1-6.471,15.328,57.836,57.836,0,0,0,3.272,30.685c5.366,13.336,14.892,32.6,14.892,32.6s-51.422-8.347-75.81,3.592c-13.088,6.4-14.266,16.593-14.266,16.593l-1.905-56.018h0L206.3,227.222Z",
    transform: "translate(3.186 -85.98)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5549",
    "data-name": "Path 5549",
    d: "M222.75,220.858a4.7,4.7,0,0,0-.684-.174c-.451-.087-1.105-.218-1.978-.349-1.745-.262-4.261-.567-7.388-.931-6.253-.713-14.906-1.585-24.461-2.5l-1.643-.16-.887-.087.7-.553q5.432-4.363,10.18-8.042a25.507,25.507,0,0,1,9.671-4.261,24.721,24.721,0,0,1,7.082-.465,17.773,17.773,0,0,1,1.905.262,2.225,2.225,0,0,1,.64.16,30.655,30.655,0,0,0-9.525.523,25.522,25.522,0,0,0-9.38,4.363l-10.18,8.086-.189-.64,1.658.16c9.554.916,18.207,1.876,24.446,2.719S222.852,220.538,222.75,220.858Z",
    transform: "translate(2.398 -67.575)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5550",
    "data-name": "Path 5550",
    d: "M174.66,214.173a5.817,5.817,0,0,1,2.007-1.774,12.914,12.914,0,0,1,6.181-1.963,12.536,12.536,0,0,1,6.341,1.323,5.817,5.817,0,0,1,2.181,1.556c-.073.1-.9-.48-2.4-1.105a14.222,14.222,0,0,0-6.093-1.062,14.078,14.078,0,0,0-5.948,1.687C175.518,213.548,174.733,214.173,174.66,214.173Z",
    transform: "translate(-2.622 -64.323)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5551",
    "data-name": "Path 5551",
    d: "M214.091,198.5c-.131,0-.567-1.832-1.643-4.712a32.649,32.649,0,0,0-6.021-10.18,20.534,20.534,0,0,0-5.09-4.028l-1.309-.654c-.422-.189-.873-.32-1.294-.465a13.959,13.959,0,0,0-2.4-.625,17.871,17.871,0,0,0-3.592-.291,5.1,5.1,0,0,1-1.352,0,4.261,4.261,0,0,1,1.338-.218,15.139,15.139,0,0,1,6.2.625c.436.145.9.262,1.352.451l1.454.654a20.36,20.36,0,0,1,5.308,4.13A30.278,30.278,0,0,1,213,193.731a27.626,27.626,0,0,1,.96,3.548,5.323,5.323,0,0,1,.131,1.222Z",
    transform: "translate(4.978 -79.393)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5552",
    "data-name": "Path 5552",
    d: "M261.023,230.388s.6-.669,1.571-1.949a22.672,22.672,0,0,0,3.33-5.817,24.46,24.46,0,0,0,1.716-9.787,22.889,22.889,0,0,0-3.563-11.547,88.56,88.56,0,0,0-7.518-9.787,44.922,44.922,0,0,1-5.744-8.406,20.358,20.358,0,0,1-2.109-6.53,12.251,12.251,0,0,1-.116-1.861,1.948,1.948,0,0,1,0-.654,12.7,12.7,0,0,0,.349,2.472,21.581,21.581,0,0,0,2.283,6.341,45.663,45.663,0,0,0,5.817,8.217,83.849,83.849,0,0,1,7.62,9.831,23.181,23.181,0,0,1,3.607,11.91,24.139,24.139,0,0,1-1.905,9.991,21.319,21.319,0,0,1-3.577,5.817,12.109,12.109,0,0,1-1.294,1.352,2.488,2.488,0,0,1-.465.407Z",
    transform: "translate(30.948 -80.843)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10554",
    "data-name": "Group 10554",
    transform: "translate(206.504 135.62)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5553",
    "data-name": "Path 5553",
    d: "M205.66,218.9a6.719,6.719,0,0,1,4.116-8.187,35.057,35.057,0,0,1,5.41-.7c1.134-.189,2.4-.756,2.632-1.891.291-1.454-1.178-2.5-2.487-3.068a22.9,22.9,0,0,0-16.971-.407,26.947,26.947,0,0,1,5.308,14.048",
    transform: "translate(-198.36 -203.214)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10555",
    "data-name": "Group 10555",
    transform: "translate(281.409 100.524)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5554",
    "data-name": "Path 5554",
    d: "M250.264,180.068c-2.312-4.639,6.079,8.391,9.991,11.794a86.294,86.294,0,0,1,11.285,10.689c3.243,4.043,5.642,8.522,5.192,13.7l-9.336-3.287s1.178-7.548-2.909-13.088S251.195,181.872,250.264,180.068Z",
    transform: "translate(-249.867 -179.081)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10556",
    "data-name": "Group 10556",
    transform: "translate(166.684 143.847)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5555",
    "data-name": "Path 5555",
    d: "M193.129,213.421c-2.574-2.792-6.515-3.926-10.3-4.363a15.822,15.822,0,0,0-6.864.451,7.388,7.388,0,0,0-4.828,4.61,2.21,2.21,0,0,0,.174,2.007,1.934,1.934,0,0,0,2.123.494,7.416,7.416,0,0,0,1.992-1.222,17.7,17.7,0,0,1,17.393-1.847",
    transform: "translate(-170.978 -208.872)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5556",
    "data-name": "Path 5556",
    d: "M198.637,188.419a3.054,3.054,0,1,1-.889-2.169A3.069,3.069,0,0,1,198.637,188.419Z",
    transform: "translate(5.482 -75.71)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5557",
    "data-name": "Path 5557",
    d: "M209.967,174.478a3.068,3.068,0,1,1-3.068-3.069,3.068,3.068,0,0,1,3.068,3.069Z",
    transform: "translate(10.629 -82.042)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5558",
    "data-name": "Path 5558",
    d: "M232.027,175.344a3.068,3.068,0,1,1-3.054-3.054A3.068,3.068,0,0,1,232.027,175.344Z",
    transform: "translate(20.65 -81.642)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5559",
    "data-name": "Path 5559",
    d: "M249.087,174.028a3.068,3.068,0,1,1-3.068-3.068A3.068,3.068,0,0,1,249.087,174.028Z",
    transform: "translate(28.4 -82.247)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5560",
    "data-name": "Path 5560",
    d: "M277.307,199.008a3.054,3.054,0,1,1-.889-2.169A3.068,3.068,0,0,1,277.307,199.008Z",
    transform: "translate(41.219 -70.899)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5561",
    "data-name": "Path 5561",
    d: "M260.087,196.894a3.054,3.054,0,1,1-.9-2.165,3.068,3.068,0,0,1,.9,2.165Z",
    transform: "translate(33.396 -71.853)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5562",
    "data-name": "Path 5562",
    d: "M263.717,182.888a3.054,3.054,0,1,1-.889-2.169,3.068,3.068,0,0,1,.889,2.169Z",
    transform: "translate(35.045 -78.222)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_306",
    "data-name": "Ellipse 306",
    cx: 3.068,
    cy: 3.068,
    r: 3.068,
    transform: "translate(330.131 109.931)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5563",
    "data-name": "Path 5563",
    d: "M304.107,190.514a3.068,3.068,0,1,1-3.054-3.054,3.068,3.068,0,0,1,3.054,3.054Z",
    transform: "translate(53.393 -74.751)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5564",
    "data-name": "Path 5564",
    d: "M251.277,213.054a3.054,3.054,0,1,1-.9-2.165A3.068,3.068,0,0,1,251.277,213.054Z",
    transform: "translate(29.394 -64.512)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5565",
    "data-name": "Path 5565",
    d: "M258.917,225.014a3.054,3.054,0,1,1-.9-2.165A3.069,3.069,0,0,1,258.917,225.014Z",
    transform: "translate(32.865 -59.08)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5566",
    "data-name": "Path 5566",
    d: "M243.207,233.068a3.054,3.054,0,1,1-.889-2.169,3.068,3.068,0,0,1,.889,2.169Z",
    transform: "translate(25.729 -55.427)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5567",
    "data-name": "Path 5567",
    d: "M233.017,246.294a3.068,3.068,0,1,1-3.054-3.054A3.068,3.068,0,0,1,233.017,246.294Z",
    transform: "translate(21.1 -49.413)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5568",
    "data-name": "Path 5568",
    d: "M257.977,244.054a3.068,3.068,0,1,1-3-3.054,3.068,3.068,0,0,1,3,3.054Z",
    transform: "translate(32.438 -50.431)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5569",
    "data-name": "Path 5569",
    d: "M217.137,255.958a3.054,3.054,0,1,1-.889-2.169A3.068,3.068,0,0,1,217.137,255.958Z",
    transform: "translate(13.886 -45.029)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5570",
    "data-name": "Path 5570",
    d: "M225.917,222.958a3.054,3.054,0,1,1-.889-2.169,3.068,3.068,0,0,1,.889,2.169Z",
    transform: "translate(17.874 -60.02)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5571",
    "data-name": "Path 5571",
    d: "M218.837,238.288a3.068,3.068,0,1,1-3.068-3.068,3.069,3.069,0,0,1,3.068,3.068Z",
    transform: "translate(14.658 -53.056)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5572",
    "data-name": "Path 5572",
    d: "M244.537,191.328a3.054,3.054,0,1,1-.889-2.169A3.068,3.068,0,0,1,244.537,191.328Z",
    transform: "translate(26.333 -74.388)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5573",
    "data-name": "Path 5573",
    d: "M231.407,208.148a3.054,3.054,0,1,1-.894-2.174,3.069,3.069,0,0,1,.894,2.174Z",
    transform: "translate(20.368 -66.747)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5574",
    "data-name": "Path 5574",
    d: "M218.837,194.8a3.068,3.068,0,1,1-3.068-3.068,3.069,3.069,0,0,1,3.068,3.068Z",
    transform: "translate(14.658 -72.812)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5575",
    "data-name": "Path 5575",
    d: "M166.917,227.384a3.068,3.068,0,1,1-3.068-3.054A3.068,3.068,0,0,1,166.917,227.384Z",
    transform: "translate(-8.927 -58.003)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5576",
    "data-name": "Path 5576",
    d: "M176.677,200.748a3.054,3.054,0,1,1-.889-2.169,3.068,3.068,0,0,1,.889,2.169Z",
    transform: "translate(-4.493 -70.109)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5577",
    "data-name": "Path 5577",
    d: "M195.4,230.364a3.069,3.069,0,1,1-3.068-3.054,3.069,3.069,0,0,1,3.068,3.054Z",
    transform: "translate(4.011 -56.649)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5578",
    "data-name": "Path 5578",
    d: "M208.227,220.524a3.068,3.068,0,1,1-3.054-3.054A3.069,3.069,0,0,1,208.227,220.524Z",
    transform: "translate(9.839 -61.119)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5579",
    "data-name": "Path 5579",
    d: "M182.617,218.248a3.054,3.054,0,1,1-.889-2.169,3.069,3.069,0,0,1,.889,2.169Z",
    transform: "translate(-1.795 -62.159)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5580",
    "data-name": "Path 5580",
    d: "M193.567,204.328a3.054,3.054,0,1,1-.889-2.169A3.068,3.068,0,0,1,193.567,204.328Z",
    transform: "translate(3.179 -68.483)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5581",
    "data-name": "Path 5581",
    d: "M240.207,405.293a87.97,87.97,0,0,1-18.786-2.032c-12.844-2.825-22.893-6.97-30.556-12.641a97.084,97.084,0,0,1-29.74,5.4c-32.983.887-62.838-9.424-99.442-39.047q-2.763-5.9-5.323-12.492c35.237,28.518,73.382,45.082,104.576,44.3a90.918,90.918,0,0,0,23.515-3.737c-8.507-8.871-12.8-20.461-12.739-34.539,0-15.43,6.631-22.425,12.128-25.566,7.78-4.465,18.425-3.854,27.762,1.585,10.3,6.006,16.419,16.157,16.375,27.165a29.841,29.841,0,0,1-11.75,23.268,89.407,89.407,0,0,1-17.291,10.4,86.063,86.063,0,0,0,57.589,9.075c30.99-6.152,56.876-17.146,76.93-32.677a124.935,124.935,0,0,0,48.747-102.9v-.131c-1.789-35.847-22.715-70.866-53.342-89.219-26.555-15.924-60.584-20.287-95.806-12.288-21.887,4.974-51.67,16.768-69.223,44.733-18.905,30.132-13.786,67.521,1.818,84.9,11.125,12.4,32.444,7.926,49.59,4.363l5.643-1.163c18.425-3.665,93.189-38.727,93.48-38.829l1.585,5.962c-1.207.422-74.72,36.211-93.654,39.978-1.8.349-3.665.742-5.57,1.149-18.905,3.97-42.552,8.915-56.469-6.588-10.063-11.227-15.662-27.427-15.764-45.62a91.618,91.618,0,0,1,13.2-47.99c18.905-30.059,50.535-42.668,73.76-47.99,37.04-8.406,72.96-3.752,101.129,13.088,32.575,19.632,54.825,56.963,56.8,95.094.16,1.949,2.109,29.754-12.768,61.224a131.291,131.291,0,0,1-38.771,47.99C316.89,385.733,290,397.134,257.862,403.562a90.25,90.25,0,0,1-17.655,1.731Zm-44.66-76.072a16.274,16.274,0,0,0-8.115,2.021c-5.512,3.156-8.435,9.831-8.478,19.313,0,13.568,4.2,24.053,13.088,31.848a82.53,82.53,0,0,0,19.72-11.2,22.6,22.6,0,0,0,8.944-17.524c0-8.391-4.741-16.186-12.783-20.869A24.912,24.912,0,0,0,195.547,329.221Z",
    transform: "translate(-56.36 -92.667)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5582",
    "data-name": "Path 5582",
    d: "M157.691,321.572a8.436,8.436,0,0,1-2.719-1.323,49.444,49.444,0,0,1-5.89-4.363,45.789,45.789,0,0,1-5.25-5.09,7.868,7.868,0,0,1-1.7-2.516c.087,0,.771.873,2.08,2.181s3.17,3.054,5.323,4.872,4.2,3.388,5.715,4.45a21.324,21.324,0,0,1,2.443,1.789Z",
    transform: "translate(-17.398 -19.868)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5583",
    "data-name": "Path 5583",
    d: "M163.6,318.788a8.812,8.812,0,0,1-3.272-.829,27.515,27.515,0,0,1-6.98-4.174,34.772,34.772,0,0,1-5.686-5.817,10.675,10.675,0,0,1-1.774-2.909c.087,0,.814.989,2.167,2.545a44.387,44.387,0,0,0,5.817,5.555,33.246,33.246,0,0,0,6.733,4.276C162.381,318.366,163.632,318.672,163.6,318.788Z",
    transform: "translate(-15.69 -21.331)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5584",
    "data-name": "Path 5584",
    d: "M138.77,307.036a3.707,3.707,0,0,1-.465-1.178,33.053,33.053,0,0,1-.843-3.345,43.133,43.133,0,0,1,1.585-22.454,29.083,29.083,0,0,1,1.294-3.185,4.535,4.535,0,0,1,.611-1.105c.116,0-.6,1.7-1.454,4.45a51.205,51.205,0,0,0-2.051,11.023,50.362,50.362,0,0,0,.494,11.183C138.407,305.277,138.887,307.007,138.77,307.036Z",
    transform: "translate(-19.885 -34.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5585",
    "data-name": "Path 5585",
    d: "M133.028,316.215a12.58,12.58,0,0,1-3.5.611,38.246,38.246,0,0,1-16.884-2.4,13.089,13.089,0,0,1-3.2-1.556,27.625,27.625,0,0,1,3.374,1.076,48.545,48.545,0,0,0,8.231,1.92,49.528,49.528,0,0,0,8.449.451A29.335,29.335,0,0,1,133.028,316.215Z",
    transform: "translate(-32.248 -17.783)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5586",
    "data-name": "Path 5586",
    d: "M269.172,282a17.445,17.445,0,0,1-2.123,3.17,77.074,77.074,0,0,1-12.827,13.161,16.706,16.706,0,0,1-3.112,2.2,25.718,25.718,0,0,1,2.749-2.53c1.745-1.556,4.116-3.752,6.617-6.3s4.625-5,6.137-6.791A26.5,26.5,0,0,1,269.172,282Z",
    transform: "translate(32.106 -31.806)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5587",
    "data-name": "Path 5587",
    d: "M122.185,247.148a9.786,9.786,0,0,1-.742-1.934,51,51,0,0,1-1.454-5.424,71,71,0,0,1-1.454-8.231,74.356,74.356,0,0,1,.538-20.432,71.255,71.255,0,0,1,1.861-8.158,55.854,55.854,0,0,1,1.818-5.337,9.946,9.946,0,0,1,.843-1.891,12.917,12.917,0,0,1-.582,1.992c-.436,1.251-.989,3.083-1.585,5.366a78.436,78.436,0,0,0-1.7,8.129,90.16,90.16,0,0,0-.916,10.18,83.552,83.552,0,0,0,.393,10.18,78.269,78.269,0,0,0,1.265,8.2c.48,2.312.931,4.174,1.294,5.439A12.407,12.407,0,0,1,122.185,247.148Z",
    transform: "translate(-28.327 -70.99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5588",
    "data-name": "Path 5588",
    d: "M128.239,186.2a12.7,12.7,0,0,1-1.76,3.883,12.958,12.958,0,0,1-2.4,3.534,12.957,12.957,0,0,1,1.774-3.883A13.51,13.51,0,0,1,128.239,186.2Z",
    transform: "translate(-25.598 -75.324)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5589",
    "data-name": "Path 5589",
    d: "M254.806,142.236c-1.731,2.763-.247,6.413,1.687,9.031s4.363,5.134,4.8,8.362c.509,4.435-3.243,8.318-7.271,10.18a7.838,7.838,0,0,0-3.432,2.138c-1.134,1.571-.669,3.723-.713,5.657a9.38,9.38,0,0,1-4.828,8.1,7.824,7.824,0,0,1-9.118-1.454,11.242,11.242,0,0,1-2.356-5.235,23.806,23.806,0,0,1,5.192-20.621c2.458-2.7,5.555-4.741,8.246-7.271s5.032-5.672,5.264-9.322",
    transform: "translate(23.888 -95.493)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5590",
    "data-name": "Path 5590",
    d: "M288.115,123.259c-2.021-5.206-7.271-8.42-12.594-10.267a35.629,35.629,0,0,0-23.632-.509c-11.081,4.014-18.527,14.339-24.257,24.635-2.487,4.479-5.279,9.482-10.18,10.98-2.618.785-5.424.422-8.144.727a16.71,16.71,0,0,0-10.878,5.817c-3.258,3.956-4.944,9.642-9.627,11.721-3.025,1.338-6.5.771-9.8.873-6.879.218-14.121,4.363-15.633,11.067-1,4.363.509,9.278-1.454,13.277-.727,1.454-1.891,2.676-2.589,4.145a7.548,7.548,0,0,0,10.98,9.525,19.746,19.746,0,0,1,3.01-2.065c2.385-1,5.1.32,7.184,1.861s4.13,3.432,6.7,3.723c5.264.582,9.351-5.817,14.644-5.41,2.909.2,5.308,2.429,7.853,3.956,4.45,2.676,6.69.276,10.456-3.287s5.817,11.445,14.543,7.533c8.115-3.665.087-17.553,3.054-17.233s10.762-.16,12.419-2.647",
    transform: "translate(-9.916 -109.614)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5591",
    "data-name": "Path 5591",
    d: "M263.2,139.04a19.749,19.749,0,0,0-2.3-17.9,25.857,25.857,0,0,0-11.111-8.464,27.791,27.791,0,0,0-18.542-1.716c-6.079,1.774-11.416,6.646-12.768,12.827-.611,2.807-.436,5.817-1.658,8.42a6.268,6.268,0,0,0-1.134,3.5,2.909,2.909,0,0,0,2.327,2.24,6.515,6.515,0,0,0,3.374-.291A35.5,35.5,0,0,0,231.57,132",
    transform: "translate(16.017 -109.893)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5592",
    "data-name": "Path 5592",
    d: "M244.194,190.3c.684-5.366.931-7.562.931-7.518s11.532-.6,15.546-15.1c2.007-7.271,3-19.3,3.5-29.216.436-8.915-4.2-20.461-13.088-20.52l-28.358,3.839a5.221,5.221,0,0,0-5.25,4.741L213,191.1s12.8,15.153,23.908,13.088S244.194,190.3,244.194,190.3Z",
    transform: "translate(14.795 -106.327)",
    fill: "#b78876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5593",
    "data-name": "Path 5593",
    d: "M246.117,139.506a1.905,1.905,0,0,1-2.036,1.7,1.818,1.818,0,0,1-1.76-1.934,1.905,1.905,0,0,1,2.036-1.7,1.818,1.818,0,0,1,1.76,1.934Z",
    transform: "translate(28.112 -97.416)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5594",
    "data-name": "Path 5594",
    d: "M248.245,136.935c-.262.218-1.571-1-3.621-1.236s-3.65.625-3.839.349.2-.538.9-.945a5.337,5.337,0,0,1,3.112-.582,4.93,4.93,0,0,1,2.836,1.294C248.216,136.368,248.391,136.834,248.245,136.935Z",
    transform: "translate(27.395 -98.815)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5595",
    "data-name": "Path 5595",
    d: "M233.321,138.172a1.92,1.92,0,0,1-2.051,1.716,1.832,1.832,0,0,1-1.76-1.934,1.905,1.905,0,0,1,2.051-1.7,1.818,1.818,0,0,1,1.76,1.92Z",
    transform: "translate(22.294 -98.016)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5596",
    "data-name": "Path 5596",
    d: "M234.437,135.621c-.262.233-1.571-1-3.607-1.222s-3.65.625-3.854.349.2-.538.9-.945a5.337,5.337,0,0,1,3.112-.582,5.1,5.1,0,0,1,2.908,1.28C234.408,135.054,234.568,135.534,234.437,135.621Z",
    transform: "translate(21.12 -99.406)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5597",
    "data-name": "Path 5597",
    d: "M236,151.177a13.089,13.089,0,0,1,3.374-.233c.538,0,1.033,0,1.163-.378a2.675,2.675,0,0,0-.174-1.585q-.524-1.963-1.091-4.145a69.091,69.091,0,0,1-2.283-10.747c.247,0,1.643,4.654,3.141,10.543.364,1.454.7,2.836,1.033,4.159a2.908,2.908,0,0,1,0,2.065,1.309,1.309,0,0,1-.931.669,4.885,4.885,0,0,1-.9,0,13.845,13.845,0,0,1-3.33-.349Z",
    transform: "translate(25.243 -98.995)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5598",
    "data-name": "Path 5598",
    d: "M241.082,164.879A37.724,37.724,0,0,1,221.9,157.36s3.81,10.791,18.745,11.081Z",
    transform: "translate(18.838 -88.424)",
    fill: "#aa6550"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5599",
    "data-name": "Path 5599",
    d: "M236.943,149.7a3.679,3.679,0,0,0-3.127-1.745,3.345,3.345,0,0,0-2.458.989,2.094,2.094,0,0,0-.436,2.4,2.472,2.472,0,0,0,2.589.989,7.751,7.751,0,0,0,2.778-1.265,1.978,1.978,0,0,0,.654-.538.7.7,0,0,0,.087-.756",
    transform: "translate(22.845 -92.699)",
    fill: "#aa6550"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5600",
    "data-name": "Path 5600",
    d: "M235.7,130.434c-.262.524-2.269,0-4.683,0s-4.363.451-4.7-.073c-.116-.262.276-.742,1.12-1.193a8.129,8.129,0,0,1,7.155,0C235.42,129.693,235.813,130.173,235.7,130.434Z",
    transform: "translate(20.835 -101.607)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5601",
    "data-name": "Path 5601",
    d: "M248.347,130.793c-.407.422-1.76-.218-3.447-.436s-3.156,0-3.432-.553c-.116-.262.16-.7.843-1.062a5.032,5.032,0,0,1,5.526.8C248.39,130.066,248.536,130.575,248.347,130.793Z",
    transform: "translate(27.715 -101.646)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5602",
    "data-name": "Path 5602",
    d: "M220.438,142.605c.116-1.105-.858-3.839-1.92-4.13-2.909-.785-8.115-1.149-8.987,6.224-1.222,10.049,9.133,9.191,9.191,8.915S220.016,146.4,220.438,142.605Z",
    transform: "translate(13.173 -97.185)",
    fill: "#b78876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5603",
    "data-name": "Path 5603",
    d: "M215.3,148.442a3.264,3.264,0,0,1-.509.2,1.731,1.731,0,0,1-1.309-.131,4.363,4.363,0,0,1-1.542-4.13,5.817,5.817,0,0,1,.8-2.458,2.007,2.007,0,0,1,1.454-1.178.887.887,0,0,1,.974.6.72.72,0,0,1,0,.509c0,.015.233-.131.2-.567a1.062,1.062,0,0,0-.32-.669,1.265,1.265,0,0,0-.931-.378,2.487,2.487,0,0,0-2.021,1.338,5.948,5.948,0,0,0-.945,2.734c-.174,2.036.625,4.057,2.036,4.654a1.847,1.847,0,0,0,1.629-.073C215.3,148.689,215.3,148.471,215.3,148.442Z",
    transform: "translate(13.947 -96.201)",
    fill: "#aa6550"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5604",
    "data-name": "Path 5604",
    d: "M253.3,120a13.844,13.844,0,0,1-10.34,9.656c-2.6.538-5.672.451-7.373,2.487s-1.149,5.381-2.792,7.533c-2.283,3-7.664,2.327-9.482,5.613-.785,1.454-.611,3.258-1.454,4.683a4.7,4.7,0,0,1-5.817,1.643,7.5,7.5,0,0,1-3.97-4.944,20.359,20.359,0,0,1-.48-6.5,35.964,35.964,0,0,1,2.254-12.623c3.519-8.289,17.029-18.905,25.915-17.451",
    transform: "translate(14.121 -109.957)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5605",
    "data-name": "Path 5605",
    d: "M250.237,157.293c2.3-2.719,4.479-5.817,6.791-8.478s4.435-5.352,4.712-8.726a14.063,14.063,0,0,0-2.458-8.027,100.9,100.9,0,0,0-9.583-13.088,13.09,13.09,0,0,0-2.69-2.647,6.515,6.515,0,0,0-3.039-1.018,3.665,3.665,0,0,0-2.53.611,2.021,2.021,0,0,0-.742,2.341,3.854,3.854,0,0,0,1.92,1.454c4.188,2.138,6.879,6.515,8.071,11.067s.858,8.944.756,13.655c-.087,3.679-.582,7.591-.96,10.98",
    transform: "translate(27.322 -107.54)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5606",
    "data-name": "Path 5606",
    d: "M256.534,110.319a30.539,30.539,0,0,0-27.907,11.75c-3.5,4.712-6.093,10.849-11.634,12.827-4.523,1.614-9.6-.189-14.339.654a13.263,13.263,0,0,0-9.729,7.708c-1.352,3.17-1.454,6.98-3.883,9.482-3.112,3.3-8.726,2.909-11.969,6.181-2.618,2.676-2.7,6.98-1.658,10.587a5.933,5.933,0,0,0,2.472,3.8,6.079,6.079,0,0,0,3.97.305,45.082,45.082,0,0,0,12.972-5.134c9.264-4.974,18.178-10.572,27.093-16.157a55.5,55.5,0,0,0,11.634-8.827c4.363-4.741,6.908-10.805,9.962-16.491s6.966-11.3,12.812-13.99",
    transform: "translate(-2.563 -109.893)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5607",
    "data-name": "Path 5607",
    d: "M163.762,203.468a1.352,1.352,0,0,1-.407-.131,4.552,4.552,0,0,1-1.12-.553,7.271,7.271,0,0,1-2.749-3.854,8.958,8.958,0,0,1,.931-7.373,15.226,15.226,0,0,1,7.9-6.006,76.292,76.292,0,0,1,11.809-2.589,27.922,27.922,0,0,0,6.341-1.949,12.71,12.71,0,0,0,8-10.98,55.492,55.492,0,0,1,1.309-7.737,19.894,19.894,0,0,1,10.7-12.216,18.906,18.906,0,0,1,8.231-1.774c2.778,0,5.468.494,8.086.669a17.974,17.974,0,0,0,7.562-.8,9.307,9.307,0,0,0,3.127-1.861,11.17,11.17,0,0,0,2.138-2.909c1.149-2.094,1.905-4.363,3.156-6.4a16.157,16.157,0,0,1,4.814-4.814,38.944,38.944,0,0,1,11.27-4.363,68.756,68.756,0,0,0,9.511-2.908,23.864,23.864,0,0,0,6.428-3.737,14.193,14.193,0,0,0,3.01-3.592c.538-.931.742-1.454.785-1.454a9.891,9.891,0,0,1-.654,1.454,13.088,13.088,0,0,1-2.908,3.723,23.094,23.094,0,0,1-6.457,3.9,65.59,65.59,0,0,1-9.525,2.909,38.873,38.873,0,0,0-11.067,4.363,15.256,15.256,0,0,0-4.61,4.639c-1.207,1.92-1.934,4.2-3.112,6.384a11.371,11.371,0,0,1-2.269,3.039,9.861,9.861,0,0,1-3.33,2.007,18.556,18.556,0,0,1-7.853.858c-2.676-.175-5.337-.625-8.042-.654a18.106,18.106,0,0,0-7.926,1.716,19.167,19.167,0,0,0-10.34,11.75,57.6,57.6,0,0,0-1.309,7.649,15.008,15.008,0,0,1-2.661,7.082,14.848,14.848,0,0,1-5.744,4.363,27.63,27.63,0,0,1-6.486,1.963,78.051,78.051,0,0,0-11.75,2.487,14.863,14.863,0,0,0-7.722,5.817,8.726,8.726,0,0,0-.974,7.082,7.271,7.271,0,0,0,2.574,3.81,15.383,15.383,0,0,0,1.338.989Z",
    transform: "translate(-9.698 -107.149)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5608",
    "data-name": "Path 5608",
    d: "M162.92,174.491a3.941,3.941,0,0,1,1.018-.989,6.952,6.952,0,0,1,3.883-1.207,19.313,19.313,0,0,1,6.37,1.076,25.316,25.316,0,0,0,3.883.887,8.522,8.522,0,0,0,4.363-.422,9.016,9.016,0,0,0,3.723-2.981,16.579,16.579,0,0,0,2.414-4.683c.625-1.731,1.105-3.592,1.76-5.468a36.357,36.357,0,0,1,2.516-5.628,21.261,21.261,0,0,1,9.235-9.293,17.058,17.058,0,0,1,6.879-1.454c2.37-.073,4.741.087,7.111-.131a10.456,10.456,0,0,0,6.311-2.5,18.906,18.906,0,0,0,3.767-5.613,28.75,28.75,0,0,1,3.461-5.817,16.477,16.477,0,0,1,5.134-4,32.3,32.3,0,0,1,11.547-2.909c3.708-.364,7.169-.494,10.282-.945a27.311,27.311,0,0,0,8.1-2.283,17.756,17.756,0,0,0,5.192-3.665,12.361,12.361,0,0,0,2.312-3.272c.407-.829.567-1.309.6-1.294a6.631,6.631,0,0,1-.465,1.352,11.91,11.91,0,0,1-2.24,3.4,17.45,17.45,0,0,1-5.221,3.825,26.961,26.961,0,0,1-8.2,2.429c-3.141.494-6.617.654-10.3,1.033a31.994,31.994,0,0,0-11.3,2.909,15.662,15.662,0,0,0-4.915,3.854,27.923,27.923,0,0,0-3.359,5.672,19.385,19.385,0,0,1-3.912,5.817,11.154,11.154,0,0,1-6.719,2.69c-2.458.218-4.843,0-7.169.131a16.215,16.215,0,0,0-6.6,1.367,20.767,20.767,0,0,0-8.958,8.973,37.813,37.813,0,0,0-2.487,5.512c-.669,1.847-1.149,3.708-1.8,5.468-1.207,3.5-3.388,6.719-6.5,7.926a9.045,9.045,0,0,1-4.566.407,25.9,25.9,0,0,1-3.926-.945,19.414,19.414,0,0,0-6.253-1.193,7.271,7.271,0,0,0-3.825,1.047C163.254,174.128,162.949,174.579,162.92,174.491Z",
    transform: "translate(-7.954 -109.075)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5609",
    "data-name": "Path 5609",
    d: "M196.078,188.152a1.182,1.182,0,0,0,.611-.276,2.632,2.632,0,0,0,1.134-1.454,3.156,3.156,0,0,0-.465-2.909,7.65,7.65,0,0,0-3.156-2.429,15.763,15.763,0,0,1-4.363-2.545,8.726,8.726,0,0,1-2.443-5.352,11.038,11.038,0,0,1,1.309-6.355,14.339,14.339,0,0,1,4.843-5,33.9,33.9,0,0,1,12.594-4.232,54.012,54.012,0,0,0,10.412-2.6,18.673,18.673,0,0,0,6.093-3.781c1.236-1.193,1.731-2.007,1.789-1.963s-.087.218-.334.6a11.1,11.1,0,0,1-1.251,1.556,18,18,0,0,1-6.093,4.057,51.2,51.2,0,0,1-10.485,2.778c-3.97.785-8.435,1.658-12.332,4.188a13.845,13.845,0,0,0-4.625,4.741,10.543,10.543,0,0,0-1.265,5.963,8.071,8.071,0,0,0,2.21,4.974,15.707,15.707,0,0,0,4.217,2.53,7.867,7.867,0,0,1,3.272,2.661,3.432,3.432,0,0,1,.393,3.141,2.676,2.676,0,0,1-1.323,1.454,1.323,1.323,0,0,1-.742.262Z",
    transform: "translate(3.141 -92.109)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5610",
    "data-name": "Path 5610",
    d: "M206.295,235.09s-1.672-1.818-1.12-3.5,1.542-2.909,1.963-2.792.276-9.1,1.963-9.8a24.138,24.138,0,0,1,3.636-1.12s1.963-5.032,3.083-4.9,13.568,2.385,13.568,2.385,9.8,10.5,9.235,11.474-1.12,2.094-2.661,1.542a17.452,17.452,0,0,1-3.01-1.542l5.221,5.715s-1,4.363-5.279,1.28l2.094,2.661s-1.265,5.468-7.417.843l-6.3-3.781h-4.057l9.235,5.643s.974,2.778-1.818,2.763-9.831-3.723-9.831-3.723-4.188,2.472-5.6,2.472-1.789-1.556-1.789-1.556Z",
    transform: "translate(11.189 -63.164)",
    fill: "#b78876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5611",
    "data-name": "Path 5611",
    d: "M229.475,230.214a24.161,24.161,0,0,1-2.167-1.861,47.034,47.034,0,0,1-5.119-4.639,4.363,4.363,0,0,0-3.141-1.454,21.276,21.276,0,0,0-3.039.189,5.715,5.715,0,0,1-2.909-.131c0-.1,1.091,0,2.807-.364a16.537,16.537,0,0,1,3.141-.364,5.351,5.351,0,0,1,1.905.378,4.813,4.813,0,0,1,1.716,1.193c1.789,2.007,3.679,3.5,4.944,4.784A7.476,7.476,0,0,1,229.475,230.214Z",
    transform: "translate(14.84 -59.248)",
    fill: "#aa6550"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5612",
    "data-name": "Path 5612",
    d: "M233.744,230.633a17.615,17.615,0,0,1-2.545-2.487c-1.527-1.585-3.636-3.767-6.021-6.108-1.207-1.149-2.327-2.327-3.418-3.185a6.311,6.311,0,0,0-3.418-1.236,22.775,22.775,0,0,0-3.534,0,2.91,2.91,0,0,1,.931-.247,14.95,14.95,0,0,1,2.632-.189,6.675,6.675,0,0,1,3.781,1.207,43.925,43.925,0,0,1,3.534,3.214,82.651,82.651,0,0,1,5.817,6.268,16.331,16.331,0,0,1,2.24,2.763Z",
    transform: "translate(15.617 -61.251)",
    fill: "#aa6550"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5613",
    "data-name": "Path 5613",
    d: "M230.911,147.1c.378-.16,1.236,1.178,2.56,2.516s2.632,2.225,2.472,2.6-1.949,0-3.49-1.6S230.547,147.22,230.911,147.1Z",
    transform: "translate(22.872 -93.089)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5614",
    "data-name": "Path 5614",
    d: "M337.691,249.25l-12.928-66.46a4.988,4.988,0,0,0-9.787,1.905l.6,3.025-26.744,6.573a17.844,17.844,0,0,0-12.492,11.154l-16.128,3.97a10.427,10.427,0,0,0-7.635,12.608l1.454,5.817-15.779,3.9a8.2,8.2,0,0,0,3.927,15.924l15.793-3.883,1.12,4.552a10.427,10.427,0,0,0,12.608,7.635l16.419-4.043V251.8a17.829,17.829,0,0,0,15.837,3.766l23.733-5.817.276,1.454a4.988,4.988,0,0,0,9.787-1.905Z",
    transform: "translate(23.43 -78.633)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5615",
    "data-name": "Path 5615",
    d: "M337.795,249.377a3.65,3.65,0,0,1,.131,1.12,4.988,4.988,0,0,1-1.134,3.083,5.036,5.036,0,0,1-8.711-1.7c-.189-.64-.276-1.294-.422-1.963l.189.116L310.4,254.394l-5.221,1.309a20.2,20.2,0,0,1-5.686.785,18.149,18.149,0,0,1-11.46-4.363l.436-.276v.116l.073.276h-.276c-5.541,1.352-11.343,2.909-17.582,4.29a10.776,10.776,0,0,1-9.118-3.2,10.558,10.558,0,0,1-2.574-4.435c-.451-1.658-.829-3.316-1.251-4.988l.393.247-13.321,3.359c-1.149.247-2.24.6-3.476.785a8.522,8.522,0,0,1-8.391-12.754,8.973,8.973,0,0,1,6.239-4.2l14.862-3.65-.262.422c-.291-1.207-.6-2.458-.916-3.723a24.285,24.285,0,0,1-.8-3.97A10.774,10.774,0,0,1,257.65,210.2a14.251,14.251,0,0,1,3.781-1.309l14.921-3.665-.233.218a18.382,18.382,0,0,1,7.519-9.176,18.587,18.587,0,0,1,5.439-2.225l5.526-1.367,21-5.134-.233.364c-.16-.785-.305-1.585-.465-2.37a6.589,6.589,0,0,1-.16-2.458,5.279,5.279,0,0,1,7.519-3.912,5.206,5.206,0,0,1,2.909,3.563l3.185,16.448c1.978,10.325,3.708,19.342,5.134,26.8s2.516,13.277,3.287,17.306c.364,1.978.64,3.5.829,4.566.087.509.16.887.2,1.178a2.1,2.1,0,0,1,0,.407,1.786,1.786,0,0,1-.1-.393,8.088,8.088,0,0,0-.247-1.163l-.945-4.566c-.8-4.014-1.963-9.86-3.447-17.262s-3.243-16.462-5.279-26.773q-1.527-7.737-3.243-16.419a4.667,4.667,0,0,0-9.162.364,5.686,5.686,0,0,0,.145,2.254c.16.785.32,1.571.465,2.37v.291l-.291.073L294.719,193.4c-3.621,1-7.519,1.454-10.761,3.5a17.727,17.727,0,0,0-7.271,8.842l-.073.175h-.174L261.519,209.6a13.38,13.38,0,0,0-3.607,1.236,10.181,10.181,0,0,0-2.909,2.4,10.005,10.005,0,0,0-2.3,7.14,22.659,22.659,0,0,0,.785,3.854c.305,1.28.625,2.53.916,3.737l.087.334-.349.087-14.775,3.65a8.158,8.158,0,0,0-5.817,3.868,7.809,7.809,0,0,0,7.693,11.634c1.105-.145,2.269-.509,3.4-.771l13.306-3.258.32-.073.073.305c.422,1.672.8,3.359,1.236,4.974A9.946,9.946,0,0,0,262,252.9a10.18,10.18,0,0,0,8.58,3.039c6.122-1.367,12.027-2.909,17.538-4.232l-.189.334v-.116l-.2-.829.64.553a17.6,17.6,0,0,0,11.125,4.232,19.558,19.558,0,0,0,5.555-.756l5.221-1.265,17.451-4.232h.16v.16c.145.669.233,1.352.407,1.949a4.754,4.754,0,0,0,.843,1.614,5.046,5.046,0,0,0,2.778,1.716,4.93,4.93,0,0,0,5.919-4.6Q337.836,249.922,337.795,249.377Z",
    transform: "translate(23.326 -78.76)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5616",
    "data-name": "Path 5616",
    d: "M302.292,246.812c-.189,0-3.3-13.757-6.951-30.8s-6.471-30.917-6.268-30.961,3.3,13.743,6.966,30.8S302.5,246.769,302.292,246.812Z",
    transform: "translate(49.347 -75.846)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5617",
    "data-name": "Path 5617",
    d: "M274.205,243.491c-.189,0-2.909-10.311-6.2-23.123s-5.686-23.268-5.5-23.268,2.909,10.311,6.2,23.152S274.395,243.491,274.205,243.491Z",
    transform: "translate(37.282 -70.372)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5618",
    "data-name": "Path 5618",
    d: "M251.062,228.48a36.006,36.006,0,0,1-2.312-7.853,67.067,67.067,0,0,1-1.6-8.027,36.472,36.472,0,0,1,2.3,7.867,68.567,68.567,0,0,1,1.614,8.013Z",
    transform: "translate(30.307 -63.331)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5619",
    "data-name": "Path 5619",
    d: "M265.279,199.8c0,.1-1.556.334-4.057.858-1.251.262-2.734.6-4.363,1.047a22,22,0,0,0-5.032,1.978,6.966,6.966,0,0,0-3.563,3.694,10.761,10.761,0,0,0-.087,4.363c.32,2.516.742,4.057.64,4.086a13.334,13.334,0,0,1-1.149-4.014,10.761,10.761,0,0,1,0-4.6,5.279,5.279,0,0,1,1.454-2.4,11.342,11.342,0,0,1,2.37-1.745,20.565,20.565,0,0,1,5.206-2.007c1.658-.422,3.17-.7,4.363-.9A16,16,0,0,1,265.279,199.8Z",
    transform: "translate(30.43 -69.156)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5620",
    "data-name": "Path 5620",
    d: "M295.66,187.66a4.711,4.711,0,0,1-1.382.422c-.887.218-2.2.524-3.81.873L277.875,191.6a26.657,26.657,0,0,0-6.573,2.3,13.714,13.714,0,0,0-4.363,3.578,11.881,11.881,0,0,0-2.167,4.741,3.286,3.286,0,0,1,.1-1.454,9.962,9.962,0,0,1,1.7-3.592,13.64,13.64,0,0,1,4.435-3.839,25.071,25.071,0,0,1,6.733-2.429c4.945-1.062,9.409-1.847,12.667-2.443,1.614-.291,2.909-.509,3.854-.654a6.4,6.4,0,0,1,1.4-.145Z",
    transform: "translate(38.295 -74.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5621",
    "data-name": "Path 5621",
    d: "M250.76,215.1a7.024,7.024,0,0,1-2.807,1.12c-1.818.494-4.363.7-7.111,1.28a14.18,14.18,0,0,0-3.65,1.28,9.205,9.205,0,0,0-2.487,1.891,13.378,13.378,0,0,0-1.585,2.472,4.523,4.523,0,0,1,1.193-2.792,8.726,8.726,0,0,1,2.559-2.152,13.161,13.161,0,0,1,3.81-1.454c2.807-.6,5.366-.713,7.155-1.076A15.36,15.36,0,0,1,250.76,215.1Z",
    transform: "translate(23.934 -62.209)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5622",
    "data-name": "Path 5622",
    d: "M295.213,179.948c0,.116-.538.1-1.309.305a5.264,5.264,0,0,0-2.545,1.571,5.09,5.09,0,0,0-1.149,2.778c-.087.785,0,1.309-.1,1.323s-.364-.451-.407-1.338a4.7,4.7,0,0,1,1.105-3.228,4.785,4.785,0,0,1,3.01-1.6C294.7,179.657,295.227,179.86,295.213,179.948Z",
    transform: "translate(49.635 -78.262)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--error-404--inject-65",
    transform: "translate(389.898 28.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5623",
    "data-name": "Path 5623",
    d: "M302.253,103.843c0,5.264-3.8,8.435-10.078,8.435h-6.631v7.795h-2.6V95.35h9.235C298.457,95.379,302.253,98.564,302.253,103.843Zm-2.6,0c0-3.941-2.6-6.2-7.548-6.2h-6.559V109.98H292.1C297.046,109.98,299.649,107.726,299.649,103.843Z",
    transform: "translate(-282.94 1.678)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5624",
    "data-name": "Path 5624",
    d: "M314.1,106.69v11.5h-2.4v-2.909a6.937,6.937,0,0,1-6.37,3.068c-4.2,0-6.777-2.2-6.777-5.4,0-2.909,1.832-5.25,7.155-5.25h5.817v-1.134c0-3.17-1.789-4.9-5.25-4.9a9.438,9.438,0,0,0-6.166,2.181l-1.134-1.861a11.809,11.809,0,0,1,7.548-2.5C311.391,99.506,314.1,101.891,314.1,106.69Zm-2.5,5.919v-3.025h-5.817c-3.592,0-4.755,1.454-4.755,3.316,0,2.152,1.731,3.49,4.683,3.49a5.933,5.933,0,0,0,5.89-3.781Z",
    transform: "translate(-275.849 3.558)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5625",
    "data-name": "Path 5625",
    d: "M331.649,99.651v16.288c0,6.384-3.141,9.278-9.278,9.278a12.914,12.914,0,0,1-8.638-2.909L315,120.4a11.081,11.081,0,0,0,7.271,2.53c4.7,0,6.849-2.152,6.849-6.733v-2.356a8.376,8.376,0,0,1-7.271,3.592,8.987,8.987,0,0,1,0-17.975,8.377,8.377,0,0,1,7.271,3.694v-3.5Zm-2.443,8.813a7.039,7.039,0,1,0-7.039,6.806,6.617,6.617,0,0,0,7.039-6.806Z",
    transform: "translate(-269.349 3.543)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5626",
    "data-name": "Path 5626",
    d: "M347.332,109.667H331.771a6.864,6.864,0,0,0,7.271,6.457,7.271,7.271,0,0,0,5.686-2.429l1.454,1.614a9.8,9.8,0,0,1-16.869-6.37,8.944,8.944,0,0,1,9.075-9.409c5.206,0,8.987,3.839,8.987,9.409C347.376,109.1,347.332,109.39,347.332,109.667Zm-15.561-1.861H344.86a6.588,6.588,0,0,0-13.088,0Z",
    transform: "translate(-261.88 3.576)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5627",
    "data-name": "Path 5627",
    d: "M368.663,107.5v10.762h-2.5V107.751c0-3.912-2.051-5.919-5.57-5.919-3.985,0-6.5,2.458-6.5,6.69v9.744h-2.5V99.636h2.4v3.417a7.78,7.78,0,0,1,7.053-3.548C365.551,99.505,368.663,102.108,368.663,107.5Z",
    transform: "translate(-251.755 3.558)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5628",
    "data-name": "Path 5628",
    d: "M366.772,108.944a9.438,9.438,0,1,1,9.453,9.453,9.118,9.118,0,0,1-9.453-9.453Zm16.331,0a6.908,6.908,0,1,0-6.864,7.271,6.762,6.762,0,0,0,6.864-7.271Z",
    transform: "translate(-244.862 3.572)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5629",
    "data-name": "Path 5629",
    d: "M393.952,118.275a5.948,5.948,0,0,1-3.912,1.309,4.915,4.915,0,0,1-5.439-5.4V102.976h-3.3v-2.123h3.3V96.81h2.516v4.043h5.628v2.123h-5.628v11.067a2.909,2.909,0,0,0,3.2,3.388,4.086,4.086,0,0,0,2.749-.96Z",
    transform: "translate(-238.259 2.341)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5630",
    "data-name": "Path 5630",
    d: "M403.2,99.856v2.181h5.715v2.123h-5.643v16.433h-2.5V104.161H397.46v-2.123h3.316V99.725a5.1,5.1,0,0,1,5.6-5.5,5.817,5.817,0,0,1,3.708,1.163l-.843,1.861a4.363,4.363,0,0,0-2.749-.916C404.339,96.366,403.2,97.558,403.2,99.856Z",
    transform: "translate(-230.919 1.157)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5631",
    "data-name": "Path 5631",
    d: "M406.162,108.944a9.438,9.438,0,1,1,9.453,9.453,9.133,9.133,0,0,1-9.453-9.453Zm16.331,0a6.908,6.908,0,1,0-6.879,7.271,6.777,6.777,0,0,0,6.879-7.271Z",
    transform: "translate(-226.968 3.572)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5632",
    "data-name": "Path 5632",
    d: "M439.414,99.6v18.556h-2.4v-3.417a7.388,7.388,0,0,1-6.66,3.563c-4.726,0-7.824-2.647-7.824-7.969V99.57h2.5v10.514c0,3.941,2.036,5.948,5.57,5.948,3.868,0,6.311-2.5,6.311-6.733V99.6Z",
    transform: "translate(-219.53 3.595)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5633",
    "data-name": "Path 5633",
    d: "M456.015,107.5v10.762h-2.472V107.751c0-3.912-2.051-5.919-5.584-5.919-3.97,0-6.486,2.458-6.486,6.69v9.744H439V99.636h2.4v3.417a7.78,7.78,0,0,1,7.053-3.548C452.9,99.505,456.015,102.108,456.015,107.5Z",
    transform: "translate(-212.049 3.558)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5634",
    "data-name": "Path 5634",
    d: "M473,94.36v26.177h-2.4v-3.679a8.013,8.013,0,0,1-7.155,3.854,9.453,9.453,0,0,1,0-18.905,8.1,8.1,0,0,1,7.053,3.665V94.36Zm-2.472,16.928a6.908,6.908,0,1,0-6.864,7.271,6.777,6.777,0,0,0,6.864-7.271Z",
    transform: "translate(-205.24 1.228)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5635",
    "data-name": "Path 5635",
    d: "M369.976,92.195H357.048v16.651H339.161V92.195H296.42V79.863l37.389-50.3h19.254L318.408,77.245H339.7V62.412h17.32V77.245h12.957Z",
    transform: "translate(-276.817 -28.208)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5636",
    "data-name": "Path 5636",
    d: "M350.74,69.625c0-26.177,14.543-41,33.986-41s33.971,14.833,33.971,41-14.383,40.981-33.971,40.981S350.74,95.8,350.74,69.625Zm49.445,0c0-18-6.341-25.479-15.517-25.479s-15.415,7.475-15.415,25.479,6.355,25.493,15.415,25.493,15.575-7.475,15.575-25.493Z",
    transform: "translate(-252.141 -28.63)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5637",
    "data-name": "Path 5637",
    d: "M476.556,92.195H463.642v16.651h-17.9V92.195H403V79.863l37.374-50.3h19.342l-34.7,47.685h21.29V62.412h17.335V77.245h12.914Z",
    transform: "translate(-228.402 -28.208)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-65",
    transform: "translate(431.053 215.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5638",
    "data-name": "Path 5638",
    d: "M475.784,173.14a1.076,1.076,0,0,1-.262.174l-.829.451-3.214,1.672-11.925,6.093-40.021,20.156-.262.145-.189-.247c-1.105-1.585-2.283-3.258-3.49-4.944l-4.959-7.039.465.1-37.3,21.538-11.111,6.341-3.025,1.672c-.32.174-.567.32-.785.422s-.276.145-.276.131,0,0,.247-.189l.756-.48,2.909-1.789,11.009-6.515,37.171-21.741.276-.174.189.276c1.6,2.24,3.272,4.625,4.988,7.024,1.193,1.7,2.37,3.374,3.49,4.944l-.451-.116,40.108-19.952,12.027-5.89,3.272-1.571.843-.378Z",
    transform: "translate(-289.726 -150.163)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5639",
    "data-name": "Path 5639",
    d: "M457.533,209.26a4.014,4.014,0,0,1-.785.218l-2.3.509-8.522,1.8-28.518,5.526-.349.073v-.349l-.64-3.534c-.131-.8-.276-1.6-.407-2.327l.407.291c-11.561,1.978-21.814,4.363-29.085,6.341-3.679.96-6.617,1.789-8.726,2.356l-2.341.654a3.971,3.971,0,0,1-.829.175,4.358,4.358,0,0,1,.785-.32l2.3-.771c2.021-.654,4.944-1.556,8.609-2.574a294.661,294.661,0,0,1,29.158-6.573h.349v.349c.131.742.276,1.542.422,2.327.218,1.222.422,2.414.625,3.534l-.422-.291,28.562-5.308,8.551-1.454,2.327-.378A2.908,2.908,0,0,1,457.533,209.26Z",
    transform: "translate(-282.076 -133.755)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5640",
    "data-name": "Path 5640",
    d: "M370.221,174.55c.174.087-3.519,8.086-8.275,17.858s-8.726,17.626-8.915,17.538,3.534-8.071,8.275-17.858S370.047,174.463,370.221,174.55Z",
    transform: "translate(-292.258 -149.522)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5641",
    "data-name": "Path 5641",
    d: "M407.611,201.513c0,.189-9.147,3.039-20.549,6.37s-20.709,5.817-20.752,5.686,9.133-3.039,20.549-6.37S407.553,201.324,407.611,201.513Z",
    transform: "translate(-286.223 -137.279)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5642",
    "data-name": "Path 5642",
    d: "M347.342,157.34a7.667,7.667,0,0,1,.6,1.454c.378,1.076.873,2.5,1.454,4.246,1.265,3.752,2.981,8.929,5.017,15.022l.145.436h-.465l-11.358-.233.364-.422c.262,1.454.553,2.909.843,4.523,1.861,10.18,3.534,19.516,4.785,26.351.567,3.3,1.033,6.006,1.367,8,.131.873.247,1.6.334,2.181a2.778,2.778,0,0,1,.073.771,3.009,3.009,0,0,1-.218-.742c-.116-.582-.276-1.294-.465-2.167l-1.585-7.955c-1.294-6.82-3.054-16.084-5-26.322-.276-1.542-.567-3.054-.829-4.508l-.087-.422h.436l11.358.291-.305.436-4.77-15.11c-.538-1.774-.974-3.214-1.294-4.363A11.824,11.824,0,0,1,347.342,157.34Z",
    transform: "translate(-297.125 -157.34)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5643",
    "data-name": "Path 5643",
    d: "M311.24,237.562c-.087-.174,7.271-3.81,16.477-8.115s16.695-7.649,16.782-7.475-7.271,3.825-16.477,8.129S311.327,237.736,311.24,237.562Z",
    transform: "translate(-311.239 -127.983)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5644",
    "data-name": "Path 5644",
    d: "M334.82,244.864a73.022,73.022,0,0,1,6.282-8.115,77.2,77.2,0,0,1,6.85-7.649,70.687,70.687,0,0,1-6.3,8.115A74.168,74.168,0,0,1,334.82,244.864Z",
    transform: "translate(-300.528 -124.743)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5645",
    "data-name": "Path 5645",
    d: "M347.536,294.017c-.189,0,1.062-14.179,2.821-31.63s3.33-31.586,3.534-31.557-1.076,14.179-2.821,31.63S347.74,294.032,347.536,294.017Z",
    transform: "translate(-294.76 -123.957)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5646",
    "data-name": "Path 5646",
    d: "M330.18,188.12a32.575,32.575,0,0,1,3.359,5.948,31.792,31.792,0,0,1,2.7,6.268,33.055,33.055,0,0,1-3.345-5.948,33.127,33.127,0,0,1-2.719-6.268Z",
    transform: "translate(-302.636 -143.358)",
    fill: "#263238"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.0f5a2fbb21cad2c0dff99537834d502d.svg";
export { ForwardRef as ReactComponent };